/*
Theme Scripts File
Author: cosme@cos.codes

This file should contain any js scripts you want to add to the site.
Instead of calling it in the header or throwing it inside wp_head()
this file will be called automatically in the footer so as not to
slow the page load.

*/

/*
global
jQuery
picturefill
gsap
ScrollTrigger
*/

function wistiaVideo(video) {
	$(video.container).data('wvid');
	const t = $(video.container);
	
	// Immediately stop and hide the video
	// try {
	// 	video.pause();
	// 	video.time(0);
	// 	video.unbind(); // Remove all event listeners
	// 	el.css({
	// 		'visibility': 'hidden',
	// 		'display': 'none',
	// 		'opacity': '0'
	// 	});
	// 	// Also hide parent containers that might show the video
	// 	el.parent().css('visibility', 'hidden');
	// } catch(e) {
	// 	console.error('Error stopping Wistia video:', e);
	// }

	
	if ( t.siblings('button[data-wvid]').length ) {
		video.bind("pause", function(){
	    	t.parent().parent().removeClass("active_video");
		});
		video.bind("end", function(){
	    	t.parent().parent().removeClass("active_video");
		});
		t.siblings('button[data-wvid]').on('click', function(){
	    	t.parent().parent().addClass("active_video");
	    	video.play();
		});
	}
	
	if ( t.data('lazyplay') && t.data('lazyplay').length ) {
		let loadVideo = ScrollTrigger.create({
					trigger: t,
					start: "top-=100 bottom",
					end: "bottom+=100 top",
					onEnter: () => { video.play(); t.addClass('loaded'); },
					onEnterBack: () => { video.play(); t.addClass('loaded'); }, // make sure it works in either direction
					invalidateOnRefresh: true,
					once: true,
					// markers: true
				});
	}
}

function offsetCenter(map, t, n, i) {
    const scale = Math.pow(2, map.getZoom()),
		worldCoordinateCenter = map.getProjection().fromLatLngToPoint(t),
		pixelOffset = new google.maps.Point((n / scale) || 0, (i / scale) || 0),
		worldCoordinateNewCenter = new google.maps.Point(
		        worldCoordinateCenter.x - pixelOffset.x,
		        worldCoordinateCenter.y + pixelOffset.y
		    ),
	    newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

    return newCenter;
}

function gMapInit(id, lat, lng, icon, name) {
	const markerIcon = $("<div>"),
			markerImg = $("<img>"),
			markerLabel = $("<p>");
	
	markerImg.attr("src", icon);
	markerLabel.text(name);
	markerIcon.attr("id", "gmap_marker-"+id);
	markerIcon.addClass("gmap_keymarker");
	markerIcon.append(markerImg);
	markerIcon.append(markerLabel);
      
	const gMapOptions = {
			scrollwheel: false,
			draggable: false,
			zoomControl: false,
			panControl: false,
			fullscreenControl: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDoubleClickZoom: false,
			clickableIcons: false,
			streetViewControl: false,
			mapTypeControl: false,
			disableDefaultUI: true,
			mapId: gmapId,
		    zoom: 15,
		    center: {lat: lat, lng: lng },
		},
		gMap = new google.maps.Map( $("#gmap-"+id)[0], gMapOptions),
		marker = new google.maps.marker.AdvancedMarkerElement({
			position: {lat: lat , lng: lng },
			map: gMap,
			title: name,
			content: markerIcon[0]
		});
	
	
			
	// LISTENERS
	google.maps.event.addListener(gMap, 'tilesloaded', function() { 
		// gMapLoaded = true;
		google.maps.event.clearListeners(gMap, 'tilesloaded'); 
		gMap.setCenter( offsetCenter(gMap, gMap.getCenter(), 0, (markerIcon.height()*-.5)) );
		$("#gmap-"+id).removeClass('lazyload');
	}); 
};

function locationsMapInit(id) {
	const markers = [],
		locationsMapBounds = new google.maps.LatLngBounds(),
		locationsMapOptions = {
			scrollwheel: false,
			draggable: true,
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_BOTTOM
		    },
			panControl: true,
			fullscreenControl: false,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDoubleClickZoom: false,
			clickableIcons: false,
			streetViewControl: false,
			mapTypeControl: false,
			mapId: gmapId,
		    zoom: 12,
		},
		locationsMap = new google.maps.Map( $("#gmap-"+id)[0], locationsMapOptions);
	
	// MAP MARKERS
	locations.forEach(function(location, index) {
		const itemClass = "locations";
		var marker = new google.maps.Marker({ 
		    group: location.group, 
		    id: location.id, 
		    title: location.title, 
		    address: location.address, 
		    website: location.url, 
		    phone: location.phone, 
		    position: {lat: location.lat, lng: location.lng}, 
		    map: locationsMap, 
		    icon: { 
			    path: google.maps.SymbolPath.CIRCLE, 
			    scale: 8.5, 
			    fillColor: "#333333", 
			    fillOpacity: 1, 
			    strokeWeight: 2, 
			    strokeColor: "#eeeeee" 
		    }, 
			zIndex: 1,
		    }); 
		    
		markers.push(marker); 
		locationsMapBounds.extend(new google.maps.LatLng(location.lat, location.lng));
		
					
		marker.addListener('click', function() { 
			var addr = location.address ? "<p>"+location.address+"</p>":"",
				phone = location.phone ? "<a href=\"tel:"+location.phone+"\">"+location.phone+"</a>":"",
				web = location.url ? "<a href=\""+location.url+"\" target=\"_blank\" rel=\"noopener noreferrer\">Visit Website</a>":"";
			infoWindow.close(); 
	        	infoWindow.setContent("<div class=\"locations-infowindow locations-group_"+location.group+"\"><h3>"+location.title+"</h3>"+addr+phone+web+"</div>");
			infoWindow.open(locationsMap, this); 
			
			// DELETE MAYBE
			/*locationsMap.panTo(offsetCenter(locationsMap, this.getPosition(), -160, 0));*/ 
			locationsMap.panTo(this.getPosition()); 
			
			$("#locations-"+id).find("#location_group-"+location.group).addClass("active_key"); 
			$("#locations-"+id).find("#location_group-"+location.group).siblings().removeClass("active_key"); 
		}); 
		
		
		marker.addListener('mouseover', function() { 
		 //   let markerIcon = (marker.type == 'branch') ? markerHover:hcMarkerHover, 
			//     markerZ = (marker.type == 'branch') ? 1:2; 
		// marker.setIcon(markerIcon); 
		// marker.setZIndex(3);
		}); 
		marker.addListener('mouseout', function() { 
		    // let markerIcon = (marker.type == 'branch') ? markerStatic:hcMarkerStatic, 
			   // markerZ = (marker.type == 'branch') ? 0:1; 
			if(!marker.active) {
				// marker.setIcon(markerIcon);
				// marker.setZIndex(markerZ);
			}
		}); 
	});
	locationsMap.fitBounds(locationsMapBounds);
						
						
	// LISTENERS
	google.maps.event.addListener(infoWindow, 'closeclick', function() { 
		/*locationsMap.panTo( offsetCenter(locationsMap, locationsMapBounds.getCenter(), -320, -120) );*/
	});
				
	$("#locations-"+id).find('button.marker_trigger').click(function() {
		var markerID = $(this).data('id');
		for (var i = 0; i < markers.length; i++) {
			if (markers[i].id === markerID) {
				var addr = markers[i].address ? "<p>"+markers[i].address+"</p>":"",
					phone = markers[i].phone ? "<a href=\"tel:"+markers[i].phone+"\">"+markers[i].phone+"</a>":"",
					web = markers[i].url ? "<a href=\""+markers[i].url+"\" target=\"_blank\" rel=\"noopener noreferrer\">Visit Website</a>":"";
				infoWindow.close(); 
	        		infoWindow.setContent("<div class=\"locations-infowindow locations-group_"+markers[i].group+"\"><h3>"+markers[i].title+"</h3>"+addr+phone+web+"</div>");
				infoWindow.open(locationsMap, markers[i]); 
				/*locationsMap.panTo(offsetCenter(locationsMap, markers[i].getPosition(), -160, 0));*/ 
				locationsMap.panTo(markers[i].getPosition()); 
			}
		}
	}); 
				
	// MAP LEGEND
	$("#locations-"+id).find('.locations-key_wrap-inner').each(function() {
		new SimpleBar( $(this)[0], {
			autoHide: false
		});
	});
				
	$("#locations-"+id).find('.locations-key_category').click(function() {
		var cat = $(this).parent();
		if( cat.hasClass('active_key') ) {
			cat.removeClass('active_key');
		} else {
			cat.siblings().removeClass('active_key');
			cat.addClass('active_key');
		}
	});
	
				
	google.maps.event.addListener(locationsMap, 'tilesloaded', function() { 
		// locationsMapLoaded = true;
		google.maps.event.clearListeners(locationsMap, 'tilesloaded'); 
	
		setTimeout(function(){$('#gmap-'+id).removeClass('lazyload');},1000);
		setTimeout(function(){$('#map_legend-'+id).removeClass('lazyload');},1200);
	}); 
};

// as the page loads, call these scripts =======================================================================================*/
jQuery(document).ready(function($) {

	// Declare nominations in outer scope
	var nominations;

	// initialize all anonymous functions
	pageScripts();
	/**************************************************************
	GENERAL PAGE SCRIPTS YOU WANT TO LOAD WITH THE PAGE
	**************************************************************/
	$('body').on('click', '.menu_trigger', function() {
		toggleMenu();
	});
	
	function osxClass() {
		var is_OSX = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),
			is_iOS = /(iPhone|iPod|iPad)/i.test(navigator.platform),
			is_Mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0,
			is_iPhone = navigator.platform == "iPhone",
			is_iPod = navigator.platform == "iPod",
			is_iPad = navigator.platform == "iPad";
		
		if (is_Mac || is_OSX || is_iOS) {
			$('#body-class').addClass('osx');
		}
	}
	
	function refreshScroll(delay, smoother) {
		setTimeout(function(){
			ScrollTrigger.refresh();
			smoother.refresh();
		}, delay);
	}
	
	function closeMenu() {
		$('body').removeClass('active_menu');
	}

	function openMenu() {
		$('body').addClass('active_menu');
	}

	function toggleMenu() {
		if ($('body').hasClass('active_menu')) {
			$('body').removeClass('active_menu');
		}
		else {
			$('body').addClass('active_menu');
		}
	}
	
	function getCookie(name) {
	    // Split cookie string and get all individual name=value pairs in an array
	    var cookieArr = document.cookie.split(";");
	    
	    // Loop through the array elements
	    for(var i = 0; i < cookieArr.length; i++) {
	        var cookiePair = cookieArr[i].split("=");
	        
	        /* Removing whitespace at the beginning of the cookie name
	        and compare it with the given string */
	        if(name == cookiePair[0].trim()) {
	            // Decode the cookie value and return
	            return decodeURIComponent(cookiePair[1]);
	        }
	    }
	    
	    // Return null if not found
	    return null;
	}


	// include all anonymous functions and/or functions that should execute on $(document).ready()
	function pageScripts() {
		osxClass();
		let mm = gsap.matchMedia(),
			smoother = ScrollSmoother.create({
				wrapper: '#main-body',
				content: '#body-class',
				smooth: 1.2,//1.625,//1.25,               // how long (in seconds) it takes to "catch up" to the native scroll position
				// smoothTouch: 0.4,//false,//0.1,
				effects: true,           // looks for data-speed and data-lag attributes on elements
				// smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
				// iPad only: it transforms the page, which kills the fixed hero on phones
				normalizeScroll: window.innerWidth >= 768,
				ignoreMobileResize: true,
			});


		var loadPage = (function() {
			var that = {};

			that.init = function() {
					that.onLoad();
					that.lazyload();
					// that.menuClick();
					that.navItemClick();
					that.logoClick();
					that.globalBanner();
					// that.smoothAnchorScrolling();
					that.videos();
					that.activeClasses();
					that.modules();
				},
				that.onLoad = function() {
					$('html').removeClass("no-js");
					var animateDelay = 1500;
					
					// ANIMATE ONLOAD ANIMATIONS
					// $('.onload').addClass('animate');
					setTimeout(function() {
						$('.onload').addClass('animate');
					}, 400);


					// ANIMATE ONLOAD ANIMATIONS WITH A DELAY
					setTimeout(function() {
					    $('.onload').removeClass('animate');
					    $('.onload').removeClass('onload');
					}, animateDelay);
					
					gsap.utils.toArray(".animated").forEach(el => {
						let animated,
							loadAnimation = () => {
								if (!animated) {
									el.onload = () => {
										el.onload = null; // avoid recursion
										animation && animation.kill();
									}
									el.classList.add('animate');
								
									setTimeout(function(){
										el.classList.remove('animated');
										el.classList.remove('animate');
									},2000);
									
									animated = true;
								}
						    },
							animation = ScrollTrigger.create({
								trigger: el,
								start: el.closest('.offering_intro-header') ? "top bottom" : "top bottom-=150px",
								end: "bottom top+=150px",
								onEnter: loadAnimation,
								onEnterBack: loadAnimation, // make sure it works in either direction
								// markers: true
							});
					});
				},
				that.lazyload = function() {
					gsap.utils.toArray("img[data-srcset]").forEach(el => {
						let lazyloaded,
							loadImg = () => {
								if (!lazyloaded) {
									const srcset = $(el).data('srcset');
									el.onload = () => {
										el.onload = null; // avoid recursion
										loadSrcset && loadSrcset.kill();
									}
									el.classList.add('lazyloaded');
									
									$(el).attr('srcset',srcset);
									$(el).removeAttr("data-srcset");
									
									lazyloaded = true;
								}
						    },
							loadSrcset = ScrollTrigger.create({
								trigger: el,
								start: "top bottom-=150px",
								end: "bottom top+=150px",
								onEnter: loadImg,
								onEnterBack: loadImg, // make sure it works in either direction
								// markers: true
							});
					});
					
					// gsap.utils.toArray("video source[data-src]").forEach(el => {
					// 	let loaded,
					// 		loadVideo = () => {
					// 			if (!loaded) {
					// 				const src = $(el).data('src'),
					// 						bg = $(el).parent().data('poster');
					// 				el.onload = () => {
					// 					el.onload = null; // avoid recursion
					// 					loadSrc && loadSrc.kill();
					// 				}
								
					// 				$(el).parent().attr('poster', bg);
					// 				$(el).parent().removeAttr("data-poster");
									
					// 				$(el).attr('src',src);
					// 				$(el).removeAttr("data-src");
								
					// 				$(el).parent()[0].load();
					// 				$(el).parent()[0].play();
									
					// 				loaded = true;
					// 			}
					// 	    },
					// 		loadSrc = ScrollTrigger.create({
					// 			trigger: el,
					// 			start: () => {
					// 					let start = $(window).height()*.5;
					// 					return "top bottom-=" + start;
					// 				},
					// 			end: () => {
					// 					let end = $(window).height()*.5;
					// 					return "bottom top+=" + end;
					// 				},
					// 			onEnter: loadVideo,
					// 			onEnterBack: loadVideo, // make sure it works in either direction
					// 			// markers: true
					// 		});
					// });
				},
				that.menuClick = function() {
					$('.menu_trigger').on('click', function() {
						toggleMenu();
					});
				},
				that.navItemClick = function() {

					// SMOOTHEN PAGE TRANSITIONS
					$('.nav a').click(function() {
						var liID = $(this).parent('li').attr('id');

						// add current menu item to selected item
						$('#' + liID).addClass('current-menu-item');
						// transition out current page menu item styles
						$('#' + liID).siblings('.current-menu-item').addClass('previous-menu-item');
						$('#' + liID).siblings('li').removeClass('current-menu-item current_page_item');
					});

				},
				that.logoClick = function() {

					$('#logo a').click(function() {
						// transition out current page menu item styles
						$('.current-menu-item').addClass('previous-menu-item').removeClass('current-menu-item current_page_item');
					});

				},
				that.globalBanner = function() {
					if ($('.global_banner-close_trigger').length) {

						$('.global_banner-close_trigger').click(function() {
							var banner = getCookie("global_banner");
								banner = banner.split('-');
							
							if(banner[0] == ("active")) {
								// set banner to INACTIVE
								document.cookie = "global_banner=in"+banner[0]+"-"+banner[1]+"; path=/; max-age=" + banner[1];
								
								$('#global_banner').addClass('close_banner');
							}

						});
					}
				},
				that.activeClasses = function() {

					// add active class to parent of whatever link the page is on
					var url = window.location.pathname,
						urlRegExp = new RegExp(url.replace(/\/$/, '') + "$"); // create regexp to match current url pathname and remove trailing slash if present as it could collide with the link in navigation in case trailing slash wasn't present there
					// now grab every link from the navigation
					$('.sub-menu a').each(function() {
						// and test its normalized href against the url pathname regexp
						if (urlRegExp.test(this.href.replace(/\/$/, ''))) {
							$(this).parent('li').addClass('active');
						}
					});

				},
				that.smoothAnchorScrolling = function() {
					// Select all links with hashes
					$('a[href*="#"]')
					  // Remove links that don't actually link to anything
					  .not('[href="#"]')
					  .not('[href="#0"]')
					  .click(function(event) {
					    // On-page links
					    if (
					      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
					      && 
					      location.hostname == this.hostname
					    ) {
					      // Figure out element to scroll to
					      var target = $(this.hash);
					      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
					      // Does a scroll target exist?
					      if (target.length) {
					        // Only prevent default if animation is actually gonna happen
					        event.preventDefault();
					        var headerHeight = $('header.header').height();
					        
					        
					        $('html, body').animate({
					          scrollTop: target.offset().top - headerHeight - 20
					        }, 600, function() {
					          // Callback after animation
					          // Must change focus!
					          var $target = $(target);
					          $target.focus();
					          if ($target.is(":focus")) { // Checking if the target was focused
					            return false;
					          } else {
					            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
					            $target.focus(); // Set focus again
					          };
					        });
					      }
					    }
					  });
				},
				that.videos = function() {
					if ($(".video_wrap-click").length) {
						
						$(".video_wrap-click").each(function() {
						    var iframe = $(this).parent().find('iframe')[0];
						    	
						    if(iframe) {
						    	var src = iframe.src,
						    		apiLoad = false;
						    	
								if (src.includes('youtube') || src.includes('youtu.be')) {
									var youtubePlayer;
									
									function onYouTubeIframeAPIReady() {
										youtubePlayer = new YT.Player(iframe, {
											events: {
												'onReady': onYoutubePlayerReady,
									            'onStateChange': onYoutubePlayerStateChange
									          }
										});
									}
									
									
									$(this).on("click", function(e) {
									    // e.preventDefault();
									    if(!apiLoad) return;
									    
									    $(this).parent().addClass('activated_video');
									    youtubePlayer.playVideo();
									});
									
									function onYoutubePlayerReady(event) {
										// event.target.playVideo();
										apiLoad = true;
									}
									// when video ends
							        function onYoutubePlayerStateChange(event) {        
							            if(event.data === 0) {          
								    		$(iframe).parent().removeClass('activated_video');
								    		youtubePlayer.pauseVideo();
								    		youtubePlayer.seekTo(0);
							            }
							        }
									
								} else if( src.includes('vimeo') ) {
									var vimeoPlayer = new Vimeo.Player(iframe);
									
									$(this).on("click", function(e) {
									    // e.preventDefault();
									    
									    $(this).parent().addClass('activated_video');
									    vimeoPlayer.play();
									});
									
									vimeoPlayer.on('ended', function(data) {
									    $(iframe).parent().removeClass('activated_video');
										vimeoPlayer.pause();
										vimeoPlayer.setCurrentTime(0);
									});
								}
						    } else {
						    	var videoPlayer = $(this).parent().find('video')[0];
						    	
						    	$(this).on("click", function(e) {
								    // e.preventDefault();
								    
								    $(this).parent().addClass('activated_video');
								    videoPlayer.play();
								});
								
								videoPlayer.addEventListener('ended', function(e) {
								    $(videoPlayer).parent().removeClass('activated_video');
								});
						    }
						});
					}
				},
				that.modules = function() {
					// that.contentDrawer();
					that.tabs();
					that.offering();
					that.classModalButtons();
					that.scrollMedia();
				},
				that.scrollMedia = function() {
					$('.scroll_media').each(function() {
						const section = this,
							wrap = section.querySelector('.scroll_media-wrap'),
							video = section.querySelector('.scroll_media-video'),
							steps = [...section.querySelectorAll('.scroll_media-step')];

						if (!video) return;

						video.src = window.innerWidth >= 768 ? video.dataset.src : (video.dataset.srcMobile || video.dataset.src);

						const build = () => {
							// seeking to exactly duration lands past the last frame and renders blank
							const end = Math.max(0, video.duration - 1 / 30),
								fade = 0.05,
								tl = gsap.timeline({
									defaults: { ease: 'none' },
									scrollTrigger: {
										trigger: wrap,
										start: 'top top',
										end: () => '+=' + (+wrap.dataset.length / 100) * window.innerHeight,
										pin: true,
										// the custom scroller pins by transform, which iOS updates a frame late and the section wobbles
										pinType: window.innerWidth < 768 ? 'fixed' : null,
										// ScrollSmoother already eases the scroll; a scrub number on top of it lags ~2s behind the wheel
										scrub: true,
										anticipatePin: 1,
										invalidateOnRefresh: true,
									},
								});

							tl.fromTo(video, { currentTime: 0 }, { currentTime: end, duration: 1 }, 0);

							steps.forEach(step => {
								// start/end is the window the copy is readable, so both fades live inside it and never overlap the neighbour
								const a = Math.max(0, +step.dataset.start / 100),
									b = Math.min(1, +step.dataset.end / 100),
									f = Math.min(fade, (b - a) / 2);

								// a start of 0 means the copy is already on screen when the section pins
								if (a > 0) tl.fromTo(step, { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0, duration: f }, a);
								else gsap.set(step, { autoAlpha: 1, y: 0 });
								// an end of 100 holds the copy on screen until the pin releases
								if (b < 1) tl.to(step, { autoAlpha: 0, y: -24, duration: f }, b - f);
							});
						};

						// Safari paints nothing until the video has been played once, and if playback is
						// blocked outright (iOS Low Power Mode) there is nothing to scrub — fall back to a
						// plain stack of the poster and all three copy blocks
						video.play().then(() => {
							video.pause();
							if (video.readyState >= 1) build();
							else video.addEventListener('loadedmetadata', build, { once: true });
						}).catch(() => section.classList.add('no_scrub'));
					});
				},
				that.contentDrawer = function() {
					if ($('.drawer-content_wrap').length) {
						// ADD max-height to each drawer
						$('.drawer-content_wrap').each(function() {
							var height = $(this).find('.drawer-content').height();
							$(this).css('max-height', height);
						});
						
						// TOGGLE active state
						$('.drawer-trigger').click(function(e) {
							$(this).blur();
							var drawer = $(this).data('drawer');

							$('#' + drawer).toggleClass('active');
						});
					}
				},
				that.offering = function() {
					// const attr = $('body').attr('data-scroll');

					// if (typeof attr !== 'undefined' && attr !== false) {
					// 	const pos = $('body').data('scroll');
					// 	smoother.scrollTo(pos);
					// 	$('body').removeAttr('data-scroll');
					// }
					if ($('.offering_intro-offering_link').length) {
						$('a.offering_intro-offering_link').on('click', function(e) {
							$('.m-scene').addClass('is-offering');
							$('#body-class').removeClass('page-parent');
							// $('body').attr('data-scroll', $(window).scrollTop() );
						});
					}
				},
				that.classModalButtons = function() {
					if ($('button.workshop_dates-apply').length) {
						
						function resetClassModal(modal) {
							modal.removeClass('active-modal');
							$('body').removeClass('scroll-lock');

							setTimeout(function() {
								modal.find('.modal-title').html('Class Application');
								modal.find('.modal-byline > span').html('TBD');
								modal.find('.gfield.gform_hidden input[type=hidden]').val('class-name');
							}, 1500);
						}

						$('button.workshop_dates-apply').on('click', function(e) {
							const el = $(this),
								modalID = el.data('modal-id'),
								modal = $("#class_modal"),
								classDetails = classModals[modalID];

							if (modal.hasClass('active-modal')) {
								resetClassModal(modal);
							}
							else {
								const titlePlain = classDetails.title.replace(/<(.|\n)*?>/g, '');
								
								modal.find('.modal-title').html(classDetails.title);
								modal.find('.modal-byline > span').html(classDetails.start_date);
								modal.find('.gfield.gform_hidden input[type=hidden]').val(titlePlain);
								
								modal.addClass('active-modal');
								$('body').addClass('scroll-lock');
							}

							modal.find('.modal-close').on('click', function(e) {
								resetClassModal(modal);
							});
						});
					}
				},
				that.tabs = function() {
					if ($(".toggle_wrap").length) {
						$(".toggle_wrap").each(function() {
						    const el = $(this),
						    	tab = el.find('.toggle_item.active>a'),
						    	x = tab.length ? tab.position().left:0,
					    		w =tab.length ? tab.outerWidth():0;
						    
						    el.find('.toggle_marker').css({
						    		'transform':'translateX('+x+'px)',
						    		'width':w,
						    		'left': 0,
							    });
						    
						    
						    el.find('.toggle_item>a').on('click', function(){
						    	const tab = $(this),
						    		x = tab.position().left,
						    		w = tab.outerWidth();
						    	
						    	tab.parent().addClass('active')
						    	tab.parent().siblings().removeClass('active');
							    el.find('.toggle_marker').css({'transform':'translateX('+x+'px)','width':w});
						    });
					    });
					}
				};

			return that;

		})();



		var parallax = (function() {
			var that = {};

			that.init = function() {
					that.header();
					that.footer();
					that.indentHeadlines();
					that.homeHero();
					that.offering();
					that.callout();
					// that.buttons();
				},
				that.header = function() {
					let showInquiry = ($("#nominee_banner").hasClass('show_inquiry')) ? true:false;
								
					let headerSticky = ScrollTrigger.create({
								trigger: $('#body-class'),
								onUpdate: self => {
										if ( $("#nominee_banner").length ) {
											if(!showInquiry) {
												nominations.minimizeBanner();
												showInquiry = true;
											} else {
												if(!$('#nominee_banner').hasClass('minimize_banner')) {
													nominations.minimizeBanner();
												}
											}
										}
									},
								start: () => {
									let start = ($(window).width() >= 768) ? 140:100;
									start = ($('#global_banner').length) ? $('#global_banner').outerHeight()+start:start;
									return "+=" + start;
								},
								end: "bottom bottom-=1",
						});
					
					mm.add("(max-width: 767px)", () => {
						let headerPxTl = ScrollTrigger.create({
										trigger: $('#body-class'),
										start: "top top",
										end: "+=70",
										onLeave: () => {
												$('header.header').addClass('stuck');
											},
										onEnterBack: () => {
												$('header.header').removeClass('stuck');
											},
										scrub: true,
										invalidateOnRefresh: true,
										// markers: true
									});
					});
					mm.add("(min-width: 768px)", () => {
						let headerTl = gsap.timeline();
							headerTl.addLabel("start")
									.to($('header.header'), .5, {y: -36, ease: "none"}, 'start')
									.to($('#inner-header'), 1, {height: 70, ease: "none"}, 'start')
						
						let headerPxTl = ScrollTrigger.create({
										animation: headerTl,
										// trigger: $('#body-class'),
										trigger: $('#body-class'),
										start: "top top",
										end: "+=72",
										onLeave: () => {
												$('header.header').addClass('stuck');
											},
										onEnterBack: () => {
												$('header.header').removeClass('stuck');
											},
										scrub: true,
										invalidateOnRefresh: true,
										// markers: true
									});
					});
				},
				that.footer = function() {
					const el = $('footer.footer');

					let footerPx = gsap.from(el.find('.footer-tagline'), 1,{
							scrollTrigger: {
								trigger: el,
								start: "top bottom",
								end: "bottom bottom-=48",
								scrub: true,
								invalidateOnRefresh: true,
								once: true,
							},
							textIndent: "-6%",
							x: "6%",
							ease: "none"
						});
				},
				that.indentHeadlines = function() {
					$('.w_indent .content-headline').each(function(){
						const el = $(this);

						let indentPx = gsap.from(el, 1,{
								scrollTrigger: {
									trigger: el,
									start: "top bottom",
									end: "top center",
									scrub: true,
									invalidateOnRefresh: true,
									once: true,
								},
								textIndent: "-5%",
								x: "5%",
								ease: "none"
							});
					});
				},
				that.homeHero = function() {
					if ($(".home_hero").length) {
						$(".home_hero").each(function() {
							const el = $(this), video = el.find('.home_hero-video')[0];
							
							// height-driven composition, capped by width on tall windows (= min(150vh, 120vw) in _home.scss)
							that.heroUnit = function() {
								return window.innerWidth >= 768 ? Math.min(window.innerHeight, window.innerWidth * .8):window.innerHeight;
							};

							// portrait tablets run the mobile chart layout (keep in sync with _home.scss)
							that.heroPortrait = function() {
								return window.matchMedia('(min-width: 768px) and (max-aspect-ratio: 9/10)').matches;
							};
							that.heroChartHeadlineY = function(el) {
								const headline = el.find('.home_hero-headline'),
									top = that.heroPortrait() ? .12 * $(window).width() : 140;
								return top + (headline.height() * .5) - parseFloat(el.find('.home_hero-headline_wrap').css('marginTop'));
							};
							// curve fitted at 768/834/900/1024; y follows the graph box so the CSS drives it
							that.heroPortraitChart = function() {
								const w = window.innerWidth,
									wrap = document.querySelector('.home_hero-graph_wrap'),
									top = wrap ? parseFloat(getComputedStyle(wrap).top):.34 * w;
								return { scale: .4439 + .00017 * w, x: -(25 + .121 * w), y: top + .1275 * w };
							};

							// Initialize stroke object that can be manipulated
							that.heroStroke = {
								progress: 0,
								// rest scale < 1 shows more of the tail arc (origin sits at the tip)
								scale: window.innerWidth >= 768 ? .8:.35,
								// portrait + mobile: slide the beam down the crack so it reads flatter
								x: window.innerWidth >= 768 ? (that.heroUnit() * -.5714 + (that.heroPortrait() ? 25:0)):window.innerWidth*-.375 + 12,
								y: window.innerWidth >= 768 ? (that.heroUnit() * .2571 + (that.heroPortrait() ? 25:0)):window.innerWidth*.275 + 12,
								rotation: 0,
								opacity: 1,
								strokeWidth: window.innerWidth >= 768 ? 1:1.4, // sub-pixel at mobile scale otherwise
								startWidth: 1.4,
								endWidth: 4.5,
								color: '#fafbfb',
								blur: 0,
								// Impact effects state
								flash: 0,
								shockR: 0,
								shockA: 0,
								impactX: null,
								impactY: null,
								tipGlow: 1,
								lineGlow: 1,
								// Path origin point - top-right corner of viewport
								originX: window.innerWidth,
								originY: 0,
								// Computed properties
								get currentWidth() {
									return this.endWidth - (this.endWidth - this.startWidth) * (1 - this.progress);
								}
							};
							
							that.initCanvasAnimation(el, that.heroStroke);

							const canvas = el.find('.home_hero-variable_stroke')[0];

							// Error-driven source fallback chain — Safari's canPlayType lies about HEVC-alpha.
							// Alpha versions have ~0.9s pre-roll before the shatter.
							let impactVideoOffset = 0.9;
							if (video) {
								const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
									srcWebm = video.dataset.srcWebm,
									srcHevc = video.dataset.srcHevc,
									srcFallback = video.dataset.srcFallback,
									breakImg = $(video).closest('.home_hero-break_img');

								const candidates = [];
								if (isSafari && srcHevc && video.canPlayType('video/mp4; codecs="hvc1"')) {
									candidates.push({ src: srcHevc, offset: 0.9, alpha: true });
								}
								if (!isSafari && srcWebm && video.canPlayType('video/webm; codecs="vp9"')) {
									candidates.push({ src: srcWebm, offset: 0.9, alpha: true });
								}
								if (srcFallback) candidates.push({ src: srcFallback, offset: 0.1, alpha: false });

								let ci = -1;
								const tryNextSource = function() {
									ci++;
									if (ci >= candidates.length) {
										// every source failed — canvas animation still runs over the static image
										video._failed = true;
										that.heroStroke.tipBoost = 1;
										$(video).css('display', 'none');
										return;
									}
									const c = candidates[ci];
									impactVideoOffset = c.offset;
									// baked-background fallback needs the edge mask
									breakImg.toggleClass('no_alpha', !c.alpha);
									// fallback star compensates for the masked-off baked light bloom
									that.heroStroke.tipBoost = c.alpha ? 0 : 1;
									video.src = c.src;
									video.load();
								};
								video.addEventListener('error', tryNextSource);
								tryNextSource();

								// Prime each source with a brief muted play — a broken Safari decoder only errors once playback starts.
								let primedSrc = null;
								video.addEventListener('canplay', function() {
									if (video._introPlayed) {
										// source became ready only after the shatter moment
										if (video.paused) {
											const late = video.play();
											if (late !== undefined) late.catch(function() {});
										}
										return;
									}
									// canplay re-fires after the prime's seek back to 0 — once is enough
									if (primedSrc === video.currentSrc) return;
									primedSrc = video.currentSrc;
									const p = video.play();
									if (p !== undefined) p.catch(function() {});
									const stopPrime = function() {
										video.removeEventListener('timeupdate', stopPrime);
										if (!video._introPlayed) {
											video.pause();
											video.currentTime = 0;
										}
									};
									video.addEventListener('timeupdate', stopPrime);
								});

								// Prepare video but don't play yet
								video.muted = true; // assert as property, Safari can ignore the attribute
								video.pause();
								video.currentTime = 0;
								
								// Make video visible immediately (showing first frame)
								setTimeout(function() {
									if (video._failed) return;
									$(video).css({
										'visibility': 'visible',
										'opacity': '1',
										'transition': 'opacity 0.5s ease'
									});
								}, 100);
							}
							
							// Remove homeload class after delay
							setTimeout(function() { 
								$('.homeload').removeClass('homeload'); 
							}, 400);
							
							// Intro: line, video and impact effects run on one timeline,
							// video starts so the shatter matches the moment the line hits the glass
							const INTRO_DURATION = 4,
								IMPACT_TIME_FRAC = 0.7, // line reaches the glass at 70% of the intro
								SHATTER_SYNC_OFFSET = 0.18, // extra delay so the tip enters the glass before it breaks
								// shatter point inside the video frame
								IMPACT_FRAC_X = 0.585,
								IMPACT_FRAC_Y = 0.364;
							
							const startHeroIntro = function() {
								if (!canvas || !canvas.buildIntroTween) {
									// canvas init failed, still play the video
									if (video && !video._failed) setTimeout(function() { video.play(); }, 1900);
									return;
								}
								
								let pImpact = 0.86;
								
								if (video) {
									const rect = video.getBoundingClientRect();
									if (rect.width > 0) {
										const ix = rect.left + rect.width * IMPACT_FRAC_X,
											iy = rect.top + rect.height * IMPACT_FRAC_Y;
										pImpact = canvas.computeImpactProgress(ix, iy);
										pImpact = Math.min(Math.max(pImpact, 0.5), 0.95);
										that.heroStroke.impactX = ix;
										that.heroStroke.impactY = iy;
									}
								}
								
								const impactTime = INTRO_DURATION * IMPACT_TIME_FRAC,
									master = gsap.timeline({ delay: 0.1 });
								
								canvas.buildIntroTween(master, pImpact, IMPACT_TIME_FRAC, INTRO_DURATION);
								
								if (video) {
									const playAt = Math.max(0, impactTime - impactVideoOffset + SHATTER_SYNC_OFFSET);
									master.call(function() {
										if (video._failed) return;
										video._introPlayed = true;
										const p = video.play();
										if (p !== undefined) {
											p.catch(function(error) {
												console.log('Hero video play prevented:', error);
											});
										}
									}, null, playAt);
								}
								
								// Impact effects: tip flash, shockwave, micro-shake
								master.call(function() {
									const draw = canvas.drawStroke;

									// blow the fallback star up to full size on impact
									if (canvas._starBloom) {
										gsap.to(canvas._starBloom, { scale: 1, opacity: 1, duration: .8, ease: "power2.out" });
									}

									gsap.fromTo(that.heroStroke, {flash: 1}, {flash: 0, duration: .45, ease: "power2.out", onUpdate: draw});
									
									if (that.heroStroke.impactX !== null) {
										const maxR = Math.max(window.innerHeight * .18, 120);
										gsap.fromTo(that.heroStroke, 
											{shockR: 10, shockA: .7}, 
											{shockR: maxR, shockA: 0, duration: .7, ease: "power2.out", onUpdate: draw});
									}
									
									const breakImg = el.find('.home_hero-break_img'),
										shakeTl = gsap.timeline();
									for (let s = 0; s < 6; s++) {
										const decay = 1 - s / 6;
										shakeTl.to(breakImg, { x: (s % 2 ? -3 : 3) * decay, y: (s % 2 ? 2 : -2) * decay, duration: .045, ease: "none" });
									}
									shakeTl.to(breakImg, { x: 0, y: 0, duration: .06, ease: "none" });
								}, null, impactTime);
							};
							
							// Start the intro once the video is ready to play
							(function beginWhenReady() {
								let started = false;
								const go = function() {
									if (started) return;
									started = true;
									startHeroIntro();
								};
								if (!video) { go(); return; }
								if (video.readyState >= 3) { go(); return; }
								video.addEventListener('canplaythrough', go, { once: true });
								setTimeout(go, 1500); // failsafe for slow networks
							})();
							
							mm.add("(max-width: 767px)", () => {
								let pxTl = gsap.timeline({
									onUpdate: function() {
										// Redraw canvas when timeline updates
										const canvas = el.find('.home_hero-variable_stroke')[0];
										if (canvas && canvas.drawStroke) {
											canvas.drawStroke();
										}
									}
								}),
									px = ScrollTrigger.create({
											animation: pxTl,
											trigger: el,
											start: "top top",
											endTrigger: el.find('.home_hero-content_wrap'),
											end: () => {
												return "top top+="+($(window).width() + 70);
											},//"bottom bottom",
											scrub: true, // keep immediate, numeric scrub lags behind the smoother

											invalidateOnRefresh: true,
											// markers: true,
										});
						
								pxTl.addLabel("enterPx")
									.to( el, 2.375, {opacity: 1, ease: "none"}, 'enterPx')
									// .to( el.find('.home_hero-break'), 2.375, {y: "237.5%", ease: "none"}, 'enterPx')
									.to( el.find('.home_hero-break'), .8, {y: 70, ease: "none"}, 'enterPx+=.2')
									.to( el.find('.home_hero-break'), .5, {"--hero-ambient": 0, ease: "none"}, 'enterPx')
									.to( el.find('.home_hero-break_img'), .5, {opacity: 0, ease: "none"}, 'enterPx')
									.to( el.find('.home_hero-break_img'), 1, {scale: .66, ease: "none"}, 'enterPx')
									// .to( el.find('.home_hero-break_point'), 1, {scaleX: .66, scaleY: .9, y: "-5%", ease: "none"}, 'enterPx')
									.to( that.heroStroke, 1, {
										scale: .225,
										y: 96,
										x: -48,
										tipGlow: .65, // soften the glow for the graph
										lineGlow: 0, // fade the line glow out into the chart
										ease: "none"
									}, 'enterPx')
										.to( el.find('.home_hero-headline>span:first-child>span:nth-child(1)'), .325, {y: "-50%", opacity: 0, ease: "none"}, 'enterPx')
										.to( el.find('.home_hero-headline>span:first-child>span:nth-child(2)'), .375, {y: "-50%", opacity: 0, ease: "none"}, 'enterPx')
										.to( el.find('.home_hero-headline>span:first-child>span:nth-child(3)'), .85, {y: "-100%", ease: "none"}, 'enterPx')
									.set( el.find('.home_hero-headline>span:first-child'), {visibility: "hidden", ease: "none"}, 'enterPx+=.8')
									.set( el.find('.home_hero-headline>span:last-child'), {visibility: "visible", ease: "none"}, 'enterPx+=.8')
										.fromTo( el.find('.home_hero-headline>span:last-child>span:nth-child(1)'), .5, {opacity: 0},{opacity: 1, ease: "none"}, 'enterPx+=.8')
										.fromTo( el.find('.home_hero-headline>span:last-child>span:nth-child(2)>span'), .5, {maxWidth: "0%", marginRight: "0em"},{maxWidth: "100%", marginRight: ".45em", ease: "none"}, 'enterPx+=1')
									// the exit fade is pinned to 100vw + 70, so the chart has to finish before it
									.to( el.find('.home_hero-headline'), .5, {y: () => { return -($(window).width()); }, ease: "none"}, 'enterPx+=1.2')
									.fromTo( el.find('.home_hero-graph_wrap'), .1, {opacity: 0},{opacity: 1, ease: "none"}, 'enterPx+=.9')
									.fromTo( el.find('.home_hero-graph_frame'), .3, {scaleX: 0},{scaleX: 1, ease: "none"}, 'enterPx+=1')
									.fromTo( el.find('.home_hero-graph_frame'), .45, {height: "2px"},{height: "100%", ease: "none"}, 'enterPx+=1.2')
									.fromTo( el.find('.home_hero-graph_labels,.home_hero-graph_y'), .25, {opacity: 0},{opacity: 1, ease: "none"}, 'enterPx+=1.5')
									.fromTo( el.find('.home_hero-graph_quote'), .25, {opacity: 0},{opacity: 1, ease: "none"}, 'enterPx+=1.6');
									
								
								let pxExit = gsap.to(".home_hero-break, .home_hero-headline_wrap", {
											scrollTrigger: {
												trigger: el.find('.home_hero-content_wrap'),
												start: () => {
													return "top top+="+($(window).width() + 70);
												},
												end: () => {
													return "top top+="+(($(window).width()*.75) + 70);
												},
												scrub: true,
												invalidateOnRefresh: true,
											},
											opacity: 0,
											ease: "none"
										});
							});
							mm.add("(min-width: 768px)", () => {
								let pxTl = gsap.timeline({
									onUpdate: function() {
										// Redraw canvas when timeline updates
										const canvas = el.find('.home_hero-variable_stroke')[0];
										if (canvas && canvas.drawStroke) {
											canvas.drawStroke();
										}
									}
								}),
									px = ScrollTrigger.create({
											pin: $('.home_hero-wrap'),
											animation: pxTl,
											trigger: el,
											start: "top top",
											end: () => {
												return ($(window).height()*2.375);
											},
											scrub: true, // keep immediate, numeric scrub lags behind the smoother

											invalidateOnRefresh: true,
											// markers: true,
										});
						
								pxTl.addLabel("enterPx")
									.to( el, 2.375, {opacity: 1, ease: "none"}, 'enterPx')
									.to( el.find('.home_hero-break'), 2.375, {y: "237.5%", ease: "none"}, 'enterPx')
									.to( el.find('.home_hero-break'), .5, {"--hero-ambient": 0, ease: "none"}, 'enterPx')
									.to( el.find('.home_hero-break_img'), .5, {opacity: 0, ease: "none"}, 'enterPx')
									.to( el.find('.home_hero-break_img'), 1, {scale: .66, top: "-5%", ease: "none"}, 'enterPx')
									// .to( el.find('.home_hero-break_point'), 1, {scale: .66, top: "-5%",x: "0vh", ease: "none"}, 'enterPx')
									.to( that.heroStroke, 1, {
										scale: ()=>{
											if (that.heroPortrait()) return that.heroPortraitChart().scale;
											const graph = el.find('.home_hero-graph');
											return ((graph.outerHeight()*.95) - 40) / (that.heroUnit()*(1.5 - .2571));
										},
										x: ()=>{
											if (that.heroPortrait()) return that.heroPortraitChart().x;
											const graph = el.find('.home_hero-graph');
											return -(graph.offset().left + 90);
										},
										y: ()=>{
											if (that.heroPortrait()) return that.heroPortraitChart().y;
											return that.heroUnit() * .2571;
										},
										tipGlow: .65, // soften the glow for the graph
										lineGlow: 0, // fade the line glow out into the chart
										ease: "none"
									}, 'enterPx')
										.to( el.find('.home_hero-headline>span:first-child>span:nth-child(1)'), .325, {y: "-50%", opacity: 0, ease: "none"}, 'enterPx')
										.to( el.find('.home_hero-headline>span:first-child>span:nth-child(2)'), .375, {y: "-50%", opacity: 0, ease: "none"}, 'enterPx')
										.to( el.find('.home_hero-headline>span:first-child>span:nth-child(3)'), .85, {y: "-100%", ease: "none"}, 'enterPx')
									.set( el.find('.home_hero-headline>span:first-child'), {visibility: "hidden", ease: "none"}, 'enterPx+=.8')
									.set( el.find('.home_hero-headline>span:last-child'), {visibility: "visible", ease: "none"}, 'enterPx+=.8')
										.fromTo( el.find('.home_hero-headline>span:last-child>span:nth-child(1)'), .5, {opacity: 0},{opacity: 1, ease: "none"}, 'enterPx+=.8')
										.fromTo( el.find('.home_hero-headline>span:last-child>span:nth-child(2)>span'), .5, {maxWidth: "0%", marginRight: "0em"},{maxWidth: "100%", marginRight: ".45em", ease: "none"}, 'enterPx+=1')
									// portrait leaves early (the beam parks at +1); landscape stays at y: 0 until below
									.to( el.find('.home_hero-headline'), .5, {y: () => that.heroPortrait() ? that.heroChartHeadlineY(el):0, ease: "none"}, 'enterPx+=.85')
									.to( el.find('.home_hero-headline'), .5, {y: () => that.heroChartHeadlineY(el), ease: "none"}, 'enterPx+=1.5')
									.fromTo( el.find('.home_hero-graph_wrap'), .1, {opacity: 0},{opacity: 1, ease: "none"}, 'enterPx+=1')
									.fromTo( el.find('.home_hero-graph_frame'), .375, {scaleX: 0},{scaleX: 1, ease: "none"}, 'enterPx+=1.125')
									.fromTo( el.find('.home_hero-graph_frame'), .65, {height: "2px"},{height: "100%", ease: "none"}, 'enterPx+=1.5')
									.fromTo( el.find('.home_hero-graph_labels,.home_hero-graph_y'), .25, {opacity: 0},{opacity: 1, ease: "none"}, 'enterPx+=2')
									.fromTo( el.find('.home_hero-graph_quote'), .25, {opacity: 0},{opacity: 1, ease: "none"}, 'enterPx+=2.125');
							});
						});
					}
				},
				that.initCanvasAnimation = function(heroElement, strokeObj) {
					const canvas = heroElement.find('.home_hero-variable_stroke')[0];
					if (!canvas) {
						console.log('Canvas not found:', heroElement);
						return;
					}
					
					try {
						const ctx = canvas.getContext('2d', { alpha: true, desynchronized: true });
						if (!ctx) {
							console.error('Canvas context not available');
							return;
						}

						// WebKit either lacks ctx.filter or runs it on the CPU — keep it on the shadow path
						const isWebKit = /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent),
							supportsCanvasFilter = typeof ctx.filter === 'string' && !isWebKit;

						// Safari renders nothing with plus-lighter over the video layer
						if (!supportsCanvasFilter) {
							canvas.style.mixBlendMode = 'screen';
						}

						// lift above the opaque fallback video that covers this canvas on small screens
						if (window.innerWidth < 768) {
							canvas.style.zIndex = 3;
						}
						
						// Constants for canvas configuration
						const CANVAS_CONFIG = {
							START_X: 1312.63,
							START_Y: 517.68,
							REF_WIDTH: 1485,
							REF_HEIGHT: 930,
							CURVE_RATIO: 0.6,
							WIDTH_SCALE_FACTOR: 1.15,
							PATH_DATA: "M1312.63,517.68C1054.69,1217.11,505.72,1575.09-50,1682.85c-979.29,189.89-5000,163.29-5000,163.29",
							POINT_COUNT: 300,
							RESIZE_DEBOUNCE: 250
						};
						
						// Safari-optimized DPI handling; touch devices get half the fill cost
						const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches,
							dpr = Math.min(window.devicePixelRatio || 1, isTouch ? 1.5:2);
						
						// Set up high-DPI canvas with viewport dimensions
						const viewportWidth = window.innerWidth;
						const viewportHeight = window.innerHeight;
						const scaledWidth = Math.floor(viewportWidth * dpr);
						const scaledHeight = Math.floor(viewportHeight * dpr);
						
						canvas.width = scaledWidth;
						canvas.height = scaledHeight;
						canvas.style.width = viewportWidth + 'px';
						canvas.style.height = viewportHeight + 'px';
						ctx.scale(dpr, dpr);

						// Glare layer above the glass so the shards catch the beam's light
						const glareCanvas = heroElement.find('.home_hero-glare')[0];
						let glareCtx = null;
						if (glareCanvas) {
							glareCtx = glareCanvas.getContext('2d', { alpha: true, desynchronized: true });
							if (glareCtx) {
								glareCanvas.width = scaledWidth;
								glareCanvas.height = scaledHeight;
								glareCanvas.style.width = viewportWidth + 'px';
								glareCanvas.style.height = viewportHeight + 'px';
								glareCtx.scale(dpr, dpr);
							}
						}

						// Pre-calculate path points once to avoid repeated parsing
						const pathPoints = that.parsePathToPoints(CANVAS_CONFIG.PATH_DATA, CANVAS_CONFIG.POINT_COUNT);
						const totalPoints = pathPoints.length;
						const originalCurveEndIndex = Math.floor(totalPoints * CANVAS_CONFIG.CURVE_RATIO);
						
						// Pre-calculate scaling factors and offsets
						let canvasWidth = viewportWidth;
						let canvasHeight = viewportHeight;
						// Height-based scaling with extra width stretch, capped by width on tall windows
						let heroRef = that.heroUnit();
						let scaleX = (heroRef / CANVAS_CONFIG.REF_HEIGHT) * CANVAS_CONFIG.WIDTH_SCALE_FACTOR;
						let scaleY = heroRef / CANVAS_CONFIG.REF_HEIGHT;
						// Anchor at top-right
						const targetOffsetFromRight = 0;
						const targetOffsetFromTop = 0;
						// Position the path's starting point at the target position
						let leftShift = canvasWidth - targetOffsetFromRight - (CANVAS_CONFIG.START_X * scaleX);
						let upShift = targetOffsetFromTop - (CANVAS_CONFIG.START_Y * scaleY);
						
						// Use the passed stroke object or create a default one
						// IMPORTANT: We use the same reference throughout so animations work correctly
						const strokeObject = strokeObj ? strokeObj : {
							progress: 0,
							scale: 1,
							x: 0,
							y: 0,
							rotation: 0,
							opacity: 1,
							strokeWidth: 1,
							startWidth: 1.4,   // Thin start for more dramatic taper
							endWidth: 4.5,     // Thicker end for more visible variation
							color: '#fafbfb',
							blur: 0,
							flash: 0,
							shockR: 0,
							shockA: 0,
							impactX: null,
							impactY: null,
							tipGlow: 1,
							lineGlow: 1,
							originX: canvasWidth,
							originY: 0
						};
						
						// Cache for transformed points only (stroke width needs to be dynamic)
						const transformedPointsCache = new Array(totalPoints);
						let cacheValid = false;
						
						const updateCaches = () => {
							// Cache transformed points
							for (let i = 0; i < totalPoints; i++) {
								transformedPointsCache[i] = {
									x: pathPoints[i].x * scaleX + leftShift,
									y: pathPoints[i].y * scaleY + upShift
								};
							}
							cacheValid = true;
						};
						
						// Initial cache population
						updateCaches();
						
						// Calculate stroke width dynamically (no caching to allow animation)
						const getStrokeWidth = (index) => {
							if (index >= originalCurveEndIndex) {
								// Extension (far left): constant thin width
								return strokeObject.startWidth * strokeObject.strokeWidth;
							} else {
								// Original curve: thin on left (high index), thick on right (low index)
								// At index 0 (rightmost): should be thick (endWidth)
								// At originalCurveEndIndex (leftmost): should be thin (startWidth)
								const progress = index / originalCurveEndIndex; // 0 at right, 1 at left
								// Apply exponential curve for dramatic variation
								const curveProgress = Math.pow(1 - progress, 2); // Cubic for more dramatic effect
								// Interpolate from thin to thick and apply strokeWidth multiplier
								const baseWidth = strokeObject.startWidth + (strokeObject.endWidth - strokeObject.startWidth) * curveProgress;
								return baseWidth * strokeObject.strokeWidth;
							}
						};
						
						const getTransformedPoint = (index) => {
							if (!cacheValid) {
								return {
									x: pathPoints[index].x * scaleX + leftShift,
									y: pathPoints[index].y * scaleY + upShift
								};
							}
							return transformedPointsCache[index];
						};
						
						// Optimized drawing function with reduced state changes
						const drawVariableStroke = () => {
							// Clear canvas with transparent background
							ctx.clearRect(0, 0, canvasWidth, canvasHeight);
							if (glareCtx) glareCtx.clearRect(0, 0, canvasWidth, canvasHeight);

							// Early return for invalid progress
							if (strokeObject.progress <= 0) return;
							
							const drawPoints = Math.floor(totalPoints * strokeObject.progress);
							if (drawPoints < 2) return;
							
							// Save context for transformations
							ctx.save();
							
							// Apply transformations from stroke object
							ctx.globalAlpha = strokeObject.opacity;
							
							// Apply blur if needed
							if (strokeObject.blur > 0) {
								if (supportsCanvasFilter) {
									ctx.filter = `blur(${strokeObject.blur}px)`;
								} else {
									// Safari: approximate the blur with a colored shadow halo
									ctx.shadowColor = strokeObject.color;
									ctx.shadowBlur = strokeObject.blur * 2;
								}
							}
							
							// Apply transformations using originX and originY as the transformation origin
							const originX = strokeObject.hasOwnProperty('originX') ? strokeObject.originX : (canvasWidth / 2);
							const originY = strokeObject.hasOwnProperty('originY') ? strokeObject.originY : (canvasHeight / 2);
							
							// Translate to origin point, apply transformations, then translate back
							ctx.translate(originX + strokeObject.x, originY + strokeObject.y);
							ctx.scale(strokeObject.scale, strokeObject.scale);
							ctx.rotate(strokeObject.rotation * Math.PI / 180);
							ctx.translate(-originX, -originY);
							
							// Set context properties once
							ctx.lineCap = 'round';
							ctx.lineJoin = 'round';
							ctx.strokeStyle = strokeObject.color;
							
							const startIndex = totalPoints - drawPoints;

							// Determine where we are in the path
							const drawEndIndex = totalPoints;

							// Line Fade (per Bryan): the line loses opacity toward its lower-left tail
							const fadeGradCache = {};
							// first point where the path leaves the viewport — the fade must finish on screen
							let fadeEndCache = null;
							const fadeEndPoint = () => {
								if (fadeEndCache) return fadeEndCache;
								const rot = (strokeObject.rotation || 0) * Math.PI / 180,
									cosR = Math.cos(rot), sinR = Math.sin(rot);
								let endIdx = totalPoints - 1;
								for (let i = startIndex; i < totalPoints; i++) {
									const p = getTransformedPoint(i),
										relX = p.x - originX, relY = p.y - originY,
										sx = originX + strokeObject.x + strokeObject.scale * (cosR * relX - sinR * relY),
										sy = originY + strokeObject.y + strokeObject.scale * (sinR * relX + cosR * relY);
									if (sy > canvasHeight || sx < 0) { endIdx = i; break; }
								}
								fadeEndCache = getTransformedPoint(endIdx);
								return fadeEndCache;
							};
							const fadeStroke = (color) => {
								// small screens/Safari use the destination-out erase below — per-segment gradients show seams
								if (!supportsCanvasFilter || window.innerWidth < 768) return color;
								if (fadeGradCache[color]) return fadeGradCache[color];
								let r = 250, g = 251, b = 251;
								if (color[0] === '#' && color.length === 7) {
									r = parseInt(color.substr(1, 2), 16);
									g = parseInt(color.substr(3, 2), 16);
									b = parseInt(color.substr(5, 2), 16);
								}
								// lg 1 = hero at rest, 0 = chart: the fade dissolves as the line becomes the key line
								const lg = strokeObject.hasOwnProperty('lineGlow') ? strokeObject.lineGlow : 1,
									ov = .2 * lg,
									p1 = getTransformedPoint(startIndex),
									pe = fadeEndPoint(),
									// overshoot keeps the tail faintly visible all the way to the screen edge
									p2 = {
										x: pe.x + (pe.x - p1.x) * ov,
										y: pe.y + (pe.y - p1.y) * ov
									},
									grad = ctx.createLinearGradient(p1.x, p1.y, p2.x, p2.y),
									stop = (t, rest, chart) => grad.addColorStop(t, 'rgba(' + r + ', ' + g + ', ' + b + ', ' + (rest * lg + chart * (1 - lg)) + ')');
								// chart column = 1: in the graph the line reads as an even key line, no fade
								stop(0, 1, 1);
								stop(0.28, 1, 1);
								stop(0.45, .85, 1);
								stop(0.6, .66, 1);
								stop(0.73, .5, 1);
								stop(0.84, .36, 1);
								stop(0.93, .24, 1);
								stop(1, 0, 1);
								fadeGradCache[color] = grad;
								return grad;
							};
							const isInExtension = startIndex >= originalCurveEndIndex;
							const crossesBoundary = startIndex < originalCurveEndIndex && drawEndIndex > originalCurveEndIndex;
							
							// Helper function to draw the stroke path
							const drawStrokePath = (colorOverride, widthMultiplier = 1, alphaOverride = null) => {
								const prevAlpha = ctx.globalAlpha;
								if (alphaOverride !== null) {
									ctx.globalAlpha = alphaOverride * strokeObject.opacity;
								}
								
								// Draw extension if needed
								if (isInExtension || crossesBoundary) {
									// Adjust start point slightly to overlap with curve boundary
									const extStart = isInExtension ? startIndex : Math.max(originalCurveEndIndex - 1, 0);
									const extEnd = drawEndIndex;
									
									ctx.strokeStyle = fadeStroke(colorOverride || strokeObject.color);
									ctx.lineWidth = strokeObject.startWidth * strokeObject.strokeWidth * widthMultiplier;
									ctx.beginPath();
									
									for (let i = extStart; i < extEnd; i++) {
										const p = getTransformedPoint(i);
										if (i === extStart) {
											ctx.moveTo(p.x, p.y);
										} else {
											ctx.lineTo(p.x, p.y);
										}
									}
									ctx.stroke();
								}
								
								// Draw original curve with segments
								if (!isInExtension) {
									const curveStart = startIndex;
									// Extend curve slightly into extension boundary to eliminate gap
									const curveEnd = Math.min(originalCurveEndIndex + 1, drawEndIndex, totalPoints);
									const curvePoints = curveEnd - curveStart;
									
									// Create variable-length segments - shorter at thin end, longer at thick end
									let segStart = curveStart;
									
									while (segStart < curveEnd) {
										// Calculate progress through the curve (0 = right/thick, 1 = left/thin)
										const progress = (segStart - curveStart) / Math.max(1, curvePoints);
										
										// Segment size varies: small (3-5) at thin end to large (curvePoints/8) at thick end
										// Use exponential curve for more dramatic variation
										const minSegSize = 3;
										const maxSegSize = Math.max(10, Math.floor(curvePoints / 8));
										const variableSegmentSize = Math.floor(
											minSegSize + (maxSegSize - minSegSize) * Math.pow(1 - progress, 2)
										);
										
										const segEnd = Math.min(segStart + variableSegmentSize, curveEnd);
										
										// Calculate width for this segment
										const midIndex = Math.floor((segStart + segEnd) / 2);
										const segmentWidth = getStrokeWidth(midIndex) * widthMultiplier;
										
										// Set width and color for this segment
										ctx.strokeStyle = fadeStroke(colorOverride || strokeObject.color);
										ctx.lineWidth = segmentWidth;
										ctx.beginPath();
										
										// Draw this segment
										let firstPoint = true;
										for (let i = segStart; i <= segEnd && i < curveEnd; i++) {
											const p = getTransformedPoint(i);
											if (firstPoint) {
												ctx.moveTo(p.x, p.y);
												firstPoint = false;
											} else {
												ctx.lineTo(p.x, p.y);
											}
										}
										
										// Add overlap with next segment for smooth connection
										if (segEnd < curveEnd - 1) {
											const nextP = getTransformedPoint(Math.min(segEnd + 1, curveEnd - 1));
											ctx.lineTo(nextP.x, nextP.y);
										}
										
										ctx.stroke();
										
										// Move to next segment
										segStart = segEnd;
									}
								}
								
								// Restore alpha
								ctx.globalAlpha = prevAlpha;
							};
							
							// Glow: one continuous blurred stroke behind the line — segments would bead
							const lineGlow = strokeObject.hasOwnProperty('lineGlow') ? strokeObject.lineGlow : 1;
							const mobileGlow = window.innerWidth < 768; // lighter halo, keeps the thin line crisp
							if (lineGlow > 0.01) {
								const prevFilter = ctx.filter;
								if (supportsCanvasFilter) ctx.filter = 'blur(2px)';
								const glowPass = (color, lineWidth, alpha) => {
									ctx.save();
									ctx.strokeStyle = fadeStroke(color);
									ctx.lineCap = 'round';
									ctx.lineJoin = 'round';
									ctx.beginPath();
									for (let i = startIndex; i < drawEndIndex; i++) {
										const p = getTransformedPoint(i);
										if (i === startIndex) ctx.moveTo(p.x, p.y);
										else ctx.lineTo(p.x, p.y);
									}
									const baseAlpha = alpha * lineGlow * strokeObject.opacity;
									if (supportsCanvasFilter) {
										ctx.globalAlpha = baseAlpha;
										ctx.lineWidth = lineWidth;
										ctx.stroke();
									} else {
										// Safari: additive shadow passes instead of blur
										ctx.globalCompositeOperation = 'lighter';
										ctx.shadowColor = color;
										ctx.shadowBlur = lineWidth * 1.5;
										ctx.globalAlpha = baseAlpha * .6;
										ctx.lineWidth = lineWidth * .8;
										ctx.stroke();
										ctx.globalAlpha = baseAlpha * .35;
										ctx.lineWidth = lineWidth * .4;
										ctx.stroke();
									}
									ctx.restore();
								};
								// Saturated outer halo, then a bright tight rim hugging the line
								if (mobileGlow) {
									glowPass('#4a9ae5', 7, 0.14);
									glowPass('#bcd8ff', 3.5, 0.28);
								} else {
									glowPass('#4a9ae5', 12, 0.22);
									glowPass('#bcd8ff', 6, 0.42);
								}
								if (supportsCanvasFilter) ctx.filter = prevFilter;
							}
							
							// 4. Draw glowing dot at the tip of the animation
							const tipGlow = strokeObject.hasOwnProperty('tipGlow') ? strokeObject.tipGlow : 1;
							if (strokeObject.progress > 0 && drawPoints > 0 && tipGlow > 0.01) {
								// Get the position of the leading edge of the stroke
								const tipIndex = totalPoints - drawPoints;
								const tipPoint = getTransformedPoint(tipIndex);
								
								// Calculate dot size based on stroke width at this point
								const tipWidth = getStrokeWidth(tipIndex);
								
								const flash = strokeObject.flash || 0;

								// two-part bloom: wide soft halo + tight hot core
								const glowRadius = Math.max(tipWidth * 10, canvasHeight * .09) * (1 + flash * 1.8);

								// fallback star: a DOM bloom riding the tip replaces the alpha video's baked-in light
								if (strokeObject.tipBoost) {
									if (!canvas._starBloom) {
										const breakEl = $(canvas).closest('.home_hero').find('.home_hero-break');
										if (breakEl.length) {
											const d = window.innerHeight * .85,
												wrap = $('<div class="home_hero-break_star" aria-hidden="true"></div>').css({
													position: 'absolute',
													inset: 0,
													// above the top vignette so the tip stays hot
													zIndex: 4,
													pointerEvents: 'none',
													// the bloom's overhang widens the iPadOS layout viewport and drags the header right
													overflow: 'hidden',
													opacity: 'var(--hero-ambient)'
												}),
												bloom = $('<div></div>').css({
													position: 'absolute',
													left: 0,
													top: 0,
													width: d,
													height: d,
													marginLeft: -d / 2,
													marginTop: -d / 2,
													mixBlendMode: 'screen',
													background: 'radial-gradient(closest-side, rgba(240,248,255,.95), rgba(200,225,255,.6) 8%, rgba(150,195,248,.34) 18%, rgba(100,155,232,.18) 34%, rgba(65,120,200,.08) 55%, rgba(50,105,185,0) 75%)'
												});
											wrap.append(bloom).appendTo(breakEl);
											canvas._starBloom = bloom[0];
											gsap.set(canvas._starBloom, { scale: .3, opacity: .85 });
										}
									}
									if (canvas._starBloom) {
										// mirror the canvas transform to place the star at the tip
										const rot = (strokeObject.rotation || 0) * Math.PI / 180,
											cosR = Math.cos(rot), sinR = Math.sin(rot),
											relX = tipPoint.x - originX, relY = tipPoint.y - originY;
										gsap.set(canvas._starBloom, {
											x: originX + strokeObject.x + strokeObject.scale * (cosR * relX - sinR * relY),
											y: originY + strokeObject.y + strokeObject.scale * (sinR * relX + cosR * relY)
										});
									}
								}

								ctx.save();
								ctx.globalAlpha = Math.min(1, strokeObject.opacity * tipGlow * (1 + flash * .65));

								// Wide soft halo — long, gentle falloff for a natural bloom
								const haloRadius = glowRadius * 2.2;
								const halo = ctx.createRadialGradient(
									tipPoint.x, tipPoint.y, 0,
									tipPoint.x, tipPoint.y, haloRadius
								);
								halo.addColorStop(0, 'rgba(130, 188, 248, .4)');
								halo.addColorStop(0.3, 'rgba(75, 142, 222, .14)');
								halo.addColorStop(0.6, 'rgba(40, 105, 185, .04)');
								halo.addColorStop(1, 'rgba(30, 90, 160, 0)');
								ctx.fillStyle = halo;
								ctx.beginPath();
								ctx.arc(tipPoint.x, tipPoint.y, haloRadius, 0, Math.PI * 2);
								ctx.fill();

								// Tight hot core with a smooth, gradual falloff
								const gradient = ctx.createRadialGradient(
									tipPoint.x, tipPoint.y, 0,
									tipPoint.x, tipPoint.y, glowRadius
								);
								gradient.addColorStop(0, 'rgba(255, 255, 255, 1)'); // Bright white center
								gradient.addColorStop(0.06, 'rgba(240, 248, 255, 1)'); // Hot white core
								gradient.addColorStop(0.16, 'rgba(175, 212, 255, .9)'); // Blue halo
								gradient.addColorStop(0.34, 'rgba(95, 160, 235, .5)');
								gradient.addColorStop(0.6, 'rgba(48, 112, 190, .18)');
								gradient.addColorStop(0.82, 'rgba(32, 92, 162, .05)');
								gradient.addColorStop(1, 'rgba(30, 90, 160, 0)'); // Fully transparent edge
								ctx.fillStyle = gradient;
								ctx.beginPath();
								ctx.arc(tipPoint.x, tipPoint.y, glowRadius, 0, Math.PI * 2);
								ctx.fill();

								ctx.restore();
							}
							
							// 3. Main stroke
							drawStrokePath(strokeObject.color, 1, 1);

							// Small screens + Safari: seam-free line fade via a destination-out gradient erase
							if (window.innerWidth < 768 || !supportsCanvasFilter) {
								// elg 1 = rest (fade ends past the screen edge), 0 = chart (no erase at all)
								const elg = strokeObject.hasOwnProperty('lineGlow') ? strokeObject.lineGlow : 1,
									eov = .2 * elg,
									fp1 = getTransformedPoint(startIndex),
									fpe = fadeEndPoint(),
									fp2 = {
										x: fpe.x + (fpe.x - fp1.x) * eov,
										y: fpe.y + (fpe.y - fp1.y) * eov
									},
									eg = ctx.createLinearGradient(fp1.x, fp1.y, fp2.x, fp2.y);
								[[0, 0, 0], [0.3, 0, 0], [0.5, .3, 0], [0.65, .55, 0], [0.78, .75, 0], [0.9, .9, 0], [1, 1, 0]].forEach(function(s) {
									eg.addColorStop(s[0], 'rgba(0, 0, 0, ' + (s[1] * elg + s[2] * (1 - elg)) + ')');
								});
								ctx.save();
								ctx.globalCompositeOperation = 'destination-out';
								ctx.globalAlpha = 1;
								ctx.fillStyle = eg;
								ctx.fillRect(Math.min(fp1.x, fp2.x) - canvasWidth * 6, Math.min(fp1.y, fp2.y) - canvasHeight * 6, canvasWidth * 12, canvasHeight * 12);
								ctx.restore();
							}

							// Restore context state
							ctx.restore();

							// Glare: a soft bloom of the line's leading portion so the shards catch the light
							if (glareCtx && lineGlow > 0.01) {
								const glareEnd = Math.min(startIndex + Math.floor(totalPoints * 0.3), drawEndIndex);
								glareCtx.save();
								if (supportsCanvasFilter) glareCtx.filter = 'blur(3px)';
								glareCtx.translate(originX + strokeObject.x, originY + strokeObject.y);
								glareCtx.scale(strokeObject.scale, strokeObject.scale);
								glareCtx.rotate(strokeObject.rotation * Math.PI / 180);
								glareCtx.translate(-originX, -originY);
								glareCtx.lineCap = 'round';
								glareCtx.lineJoin = 'round';
								// taper to nothing — a hard cutoff at glareEnd reads as a blunt line end
								const gp1 = getTransformedPoint(startIndex),
									gp2 = getTransformedPoint(Math.max(glareEnd - 1, startIndex)),
									glareFade = (color) => {
										const r = parseInt(color.substr(1, 2), 16),
											g = parseInt(color.substr(3, 2), 16),
											b = parseInt(color.substr(5, 2), 16),
											grad = glareCtx.createLinearGradient(gp1.x, gp1.y, gp2.x, gp2.y);
										grad.addColorStop(0, 'rgba(' + r + ', ' + g + ', ' + b + ', 1)');
										grad.addColorStop(0.5, 'rgba(' + r + ', ' + g + ', ' + b + ', .8)');
										grad.addColorStop(0.8, 'rgba(' + r + ', ' + g + ', ' + b + ', .35)');
										grad.addColorStop(1, 'rgba(' + r + ', ' + g + ', ' + b + ', 0)');
										return grad;
									};
								const glarePass = (color, lineWidth, alpha) => {
									glareCtx.strokeStyle = glareFade(color);
									glareCtx.beginPath();
									for (let i = startIndex; i < glareEnd; i++) {
										const p = getTransformedPoint(i);
										if (i === startIndex) glareCtx.moveTo(p.x, p.y);
										else glareCtx.lineTo(p.x, p.y);
									}
									const baseAlpha = alpha * lineGlow * strokeObject.opacity;
									if (supportsCanvasFilter) {
										glareCtx.globalAlpha = baseAlpha;
										glareCtx.lineWidth = lineWidth;
										glareCtx.stroke();
									} else {
										// Safari: soft shadow + additive blend instead of blur
										glareCtx.globalCompositeOperation = 'lighter';
										glareCtx.shadowColor = color;
										glareCtx.shadowBlur = lineWidth * 1.5;
										glareCtx.globalAlpha = baseAlpha * .7;
										glareCtx.lineWidth = lineWidth * .7;
										glareCtx.stroke();
									}
								};
								// small screens: skip the glare strokes, they read as blur on the thin line
								if (!supportsCanvasFilter || window.innerWidth >= 768) {
									glarePass('#8fc0ff', 11, 0.3);
									glarePass('#e8f2ff', 4.5, 0.5);
								}

								// mirror the tip star here so it shines over the glass
								if (tipGlow > 0.01) {
									const tp = getTransformedPoint(startIndex),
										fl = strokeObject.flash || 0,
										tr = Math.max(getStrokeWidth(startIndex) * 10, canvasHeight * .09) * (1 + fl * 1.8) * 1.15;
									const tg = glareCtx.createRadialGradient(tp.x, tp.y, 0, tp.x, tp.y, tr);
									tg.addColorStop(0, 'rgba(255, 255, 255, 1)');
									tg.addColorStop(0.15, 'rgba(220, 238, 255, .8)');
									tg.addColorStop(0.38, 'rgba(150, 195, 248, .32)');
									tg.addColorStop(0.65, 'rgba(80, 140, 220, .08)');
									tg.addColorStop(1, 'rgba(50, 105, 185, 0)');
									glareCtx.globalCompositeOperation = 'source-over';
									glareCtx.globalAlpha = Math.min(1, strokeObject.opacity * tipGlow * (1 + fl * .65)) * lineGlow;
									glareCtx.fillStyle = tg;
									glareCtx.beginPath();
									glareCtx.arc(tp.x, tp.y, tr, 0, Math.PI * 2);
									glareCtx.fill();
								}
								glareCtx.restore();
							}
							
							// 5. Shockwave rings at the impact point (viewport coords, outside the stroke transform)
							if (strokeObject.shockA > 0 && strokeObject.impactX !== null) {
								ctx.save();
								ctx.globalAlpha = strokeObject.shockA * strokeObject.opacity * .4;
								ctx.strokeStyle = '#4398d9';
								ctx.lineWidth = 7;
								ctx.beginPath();
								ctx.arc(strokeObject.impactX, strokeObject.impactY, strokeObject.shockR, 0, Math.PI * 2);
								ctx.stroke();
								ctx.globalAlpha = strokeObject.shockA * strokeObject.opacity;
								ctx.strokeStyle = 'rgba(159, 197, 242, 1)';
								ctx.lineWidth = 2;
								ctx.beginPath();
								ctx.arc(strokeObject.impactX, strokeObject.impactY, strokeObject.shockR, 0, Math.PI * 2);
								ctx.stroke();
								ctx.restore();
							}
						};
						
						// Several tweens can update the stroke in the same tick, draw only once per frame
						let lastDrawFrame = -1;
						const scheduleDraw = () => {
							if (gsap.ticker.frame === lastDrawFrame) return;
							lastDrawFrame = gsap.ticker.frame;
							drawVariableStroke();
						};
						
						// Animation state
						let isAnimating = false;
						let animationFrame = null;
						let canvasAnimation = null;
						
						// Find the progress value at which the line tip reaches a given viewport point
						canvas.computeImpactProgress = function(targetX, targetY) {
							const ox = strokeObject.originX, oy = strokeObject.originY,
								s = strokeObject.scale,
								rad = (strokeObject.rotation || 0) * Math.PI / 180,
								cos = Math.cos(rad), sin = Math.sin(rad);
							
							let bestIdx = 0, bestDist = Infinity;
							for (let i = 0; i < totalPoints; i++) {
								const p = getTransformedPoint(i),
									dx = p.x - ox, dy = p.y - oy,
									px = ox + strokeObject.x + s * (dx * cos - dy * sin),
									py = oy + strokeObject.y + s * (dx * sin + dy * cos),
									dist = (px - targetX) * (px - targetX) + (py - targetY) * (py - targetY);
								if (dist < bestDist) {
									bestDist = dist;
									bestIdx = i;
								}
							}
							return (totalPoints - bestIdx) / totalPoints;
						};
						
						// Intro tween: accelerates into the impact point, then eases out to the end
						canvas.buildIntroTween = function(timeline, pImpact, timeFrac, duration) {
							const impactEase = function(t) {
								if (t <= timeFrac) {
									return pImpact * Math.pow(t / timeFrac, 2.2);
								}
								const r = (t - timeFrac) / (1 - timeFrac);
								return pImpact + (1 - pImpact) * (1 - Math.pow(1 - r, 3));
							};
							
							canvasAnimation = gsap.to(strokeObject, {
								progress: 1,
								duration: duration,
								ease: impactEase,
								onStart: function() {
									isAnimating = true;
									canvas.classList.add('animating');
								},
								onUpdate: function() {
									if (isAnimating) {
										scheduleDraw();
									}
								},
								onComplete: function() {
									isAnimating = false;
									canvas.classList.remove('animating');
									// Final draw to ensure complete stroke
									strokeObject.progress = 1;
									drawVariableStroke();
									// Trigger a custom event when canvas animation completes
									$(canvas).trigger('canvasAnimationComplete');
								}
							});
							
							timeline.add(canvasAnimation, 0);
							canvas.gsapAnimation = canvasAnimation;
							return canvasAnimation;
						};
						
						// Store reference to stroke object on canvas for external access
						canvas.strokeObject = strokeObject;
						
						// Store drawing function for external access
						canvas.drawStroke = scheduleDraw;
						
						// Store animation and cleanup function
						canvas.gsapAnimation = canvasAnimation;
						canvas.cleanup = function() {
							isAnimating = false;
							if (animationFrame) {
								cancelAnimationFrame(animationFrame);
								animationFrame = null;
							}
							if (canvasAnimation) {
								canvasAnimation.kill();
							}
							// Clear canvas and reset context
							if (ctx) {
								ctx.clearRect(0, 0, canvasWidth, canvasHeight);
								ctx.resetTransform();
							}
							// Remove references to prevent memory leaks
							canvas.gsapAnimation = null;
						};
						
						// Cleanup on page visibility change (Safari background optimization)
						const handleVisibilityChange = () => {
							if (document.hidden && isAnimating) {
								isAnimating = false;
							} else if (!document.hidden && canvas.gsapAnimation) {
								isAnimating = true;
							}
						};
						
						document.addEventListener('visibilitychange', handleVisibilityChange);
						
						// Store visibility change handler for cleanup
						canvas.visibilityHandler = handleVisibilityChange;
						
						// Handle window resize to update canvas dimensions
						let resizeTimeout, lastW = viewportWidth, lastH = viewportHeight;
						const handleResize = () => {
							// ignore the address-bar collapse: rebuilding the canvas only shifts the beam
							if (isTouch && window.innerWidth === lastW && Math.abs(window.innerHeight - lastH) < 200) return;
							lastW = window.innerWidth;
							lastH = window.innerHeight;
							clearTimeout(resizeTimeout);
							resizeTimeout = setTimeout(() => {
								// Update canvas dimensions to match viewport
								canvas.width = window.innerWidth * dpr;
								canvas.height = window.innerHeight * dpr;
								canvas.style.width = window.innerWidth + 'px';
								canvas.style.height = window.innerHeight + 'px';
								
								// Reset context scale
								ctx.setTransform(1, 0, 0, 1, 0, 0);
								ctx.scale(dpr, dpr);

								// Keep the glare layer in sync
								if (glareCanvas && glareCtx) {
									glareCanvas.width = window.innerWidth * dpr;
									glareCanvas.height = window.innerHeight * dpr;
									glareCanvas.style.width = window.innerWidth + 'px';
									glareCanvas.style.height = window.innerHeight + 'px';
									glareCtx.setTransform(1, 0, 0, 1, 0, 0);
									glareCtx.scale(dpr, dpr);
								}

								// Recalculate scaling factors with new dimensions
								const newCanvasWidth = window.innerWidth;
								const newCanvasHeight = window.innerHeight;
								heroRef = that.heroUnit();
								const newScaleX = (heroRef / CANVAS_CONFIG.REF_HEIGHT) * CANVAS_CONFIG.WIDTH_SCALE_FACTOR;
								const newScaleY = heroRef / CANVAS_CONFIG.REF_HEIGHT;
								
								// Update the closure variables for drawing
								canvasWidth = newCanvasWidth;
								canvasHeight = newCanvasHeight;
								scaleX = newScaleX;
								scaleY = newScaleY;
								leftShift = newCanvasWidth - targetOffsetFromRight - (CANVAS_CONFIG.START_X * newScaleX);
								upShift = targetOffsetFromTop - (CANVAS_CONFIG.START_Y * newScaleY);
								
								// Update stroke object's origin to match new viewport dimensions
								strokeObject.originX = newCanvasWidth;
								strokeObject.originY = 0;
								// Don't reset x and y - let the animation timeline control these values
								// The timeline will handle updating these based on scroll position
								
								// Invalidate cache and update
								cacheValid = false;
								updateCaches();
								
								// Redraw if animation is complete or in progress
								if (strokeObject.progress > 0) {
									drawVariableStroke();
								}
							}, CANVAS_CONFIG.RESIZE_DEBOUNCE);
						};
						
						// Add resize listener
						window.addEventListener('resize', handleResize);
						
						// Store resize handler for cleanup
						canvas.resizeHandler = handleResize;
						
						// Update cleanup function to remove resize listener
						const originalCleanup = canvas.cleanup;
						canvas.cleanup = function() {
							originalCleanup.call(this);
							window.removeEventListener('resize', handleResize);
							clearTimeout(resizeTimeout);
						};
						
					} catch (error) {
						console.error('Canvas animation error:', error);
					}
				},
				that.parsePathToPoints = function(pathData, numPoints) {
					// Parse SVG path data into bezier curve points
					const coords = pathData.match(/[-+]?[0-9]*\.?[0-9]+/g).map(Number);
					const startX = coords[0], startY = coords[1];
					const cp1X = coords[2], cp1Y = coords[3];
					const cp2X = coords[4], cp2Y = coords[5];
					const endX = coords[6], endY = coords[7];
					
					const points = [];
					
					// Generate the original curve (60% of points)
					const originalCurvePoints = Math.floor(numPoints * 0.6);
					for (let i = 0; i <= originalCurvePoints; i++) {
						const t = i / originalCurvePoints;
						const x = Math.pow(1-t, 3) * startX + 
								  3 * Math.pow(1-t, 2) * t * cp1X + 
								  3 * (1-t) * Math.pow(t, 2) * cp2X + 
								  Math.pow(t, 3) * endX;
						const y = Math.pow(1-t, 3) * startY + 
								  3 * Math.pow(1-t, 2) * t * cp1Y + 
								  3 * (1-t) * Math.pow(t, 2) * cp2Y + 
								  Math.pow(t, 3) * endY;
						
						points.push({x, y});
					}
					
					// Calculate the tangent at the end of the original curve
					const tangentX = 3 * (endX - cp2X);
					const tangentY = 3 * (endY - cp2Y);
					
					// Normalize tangent
					const tangentMag = Math.sqrt(tangentX * tangentX + tangentY * tangentY);
					const normTangentX = tangentX / tangentMag;
					const normTangentY = tangentY / tangentMag;
					
					// Simple extension with quick initial curve then subtle decline
					const extensionPoints = numPoints - originalCurvePoints;
					const finalX = -5000;
					
					// The target Y position after the initial 5% curve
					const targetY = endY + normTangentY * 500;//100; // Y position after curve
					const subtleDecline = 30; // How much to decline over the remaining distance
					
					for (let i = 1; i <= extensionPoints; i++) {
						const t = i / extensionPoints;
						// Linear interpolation for X
						const x = endX + (finalX - endX) * t;
						
						// Y position: curve happens in first 5%, then subtle decline
						let y;
						if (t <= 0.3) {
							// First 5%: smooth curve using ease-out cubic
							const curveT = t / 0.3; // Normalize to 0-1 for the curve portion
							const easeOut = 1 - Math.pow(1 - curveT, 2.5); // Cubic ease-out
							y = endY + (targetY - endY) * easeOut;
						} else {
							// After 5%: subtle linear decline
							const declineT = (t - 0.3) / 0.7; // Normalize remaining portion to 0-1
							y = targetY + subtleDecline * declineT; // Gentle downward slope
						}
						
						points.push({x, y});
					}
					
					return points;
				},
				that.offering = function() {
					if($('#offering_intro').length) {
						$('#offering_intro').each(function() {
							const el = $(this);
							
							setTimeout(function() {
								el.removeClass('offeringload');
							}, 400);
							
							mm.add("(max-width: 767px)", () => {
								let bgAnim = gsap.to(el.find('.offering_intro-bg>span'), {
											scrollTrigger: {
												trigger: el,
												start: "top top",
												endTrigger: el.find('.offering_intro-process_wrap'),
												end: "top bottom",
												scrub: true,
												invalidateOnRefresh: true,
											},
											ease: "none", 
											scale: 2,
											opacity: .2
										}),
									bgFade = gsap.to(el.find('.offering_intro-bg'), {
											scrollTrigger: {
												trigger: el.find('.offering_intro-process_wrap'),
												start: "top bottom",
												end: "top top",
												scrub: true,
												invalidateOnRefresh: true,
											},
											ease: "none", 
											opacity: 0
										});
							});
							mm.add("(min-width: 768px)", () => {
								let bg = gsap.to(el.find('.offering_intro-bg'), {
											scrollTrigger: {
												trigger: el,
												start: "top top",
												endTrigger: el.find('.offering_intro-process_wrap'),
												end: "top top",
												scrub: true,
												invalidateOnRefresh: true,
											},
											ease: "none", 
											y: () => {
												const start = el[0].offsetTop,
													end = el.find('.offering_intro-process_wrap')[0].offsetTop;
													
												return (end - start);
											}
										}),
									bgAnim = gsap.to(el.find('.offering_intro-bg>span'), {
											scrollTrigger: {
												trigger: el,
												start: "top top",
												endTrigger: el.find('.offering_intro-process_wrap'),
												end: "top bottom",
												scrub: true,
												invalidateOnRefresh: true,
											},
											ease: "none", 
											scale: 2,
											opacity: .2
										}),
									bgFade = gsap.to(el.find('.offering_intro-bg'), {
											scrollTrigger: {
												trigger: el.find('.offering_intro-process_wrap'),
												start: "top bottom",
												end: "top top",
												scrub: true,
												invalidateOnRefresh: true,
											},
											ease: "none", 
											opacity: 0
										});
							});
						});
					}
					if($('hr.dark_light').length) {
						let modeToggle = gsap.to($('hr.dark_light'), {
								scrollTrigger: {
									trigger: $('hr.dark_light'),
									start: 'top center',
									endTrigger: $('#main'),
									end: 'bottom center',
									toggleClass: {targets: "#main", className: "light_bg"},
									invalidateOnRefresh: true,
								}
							});
					}
				}
				that.callout = function() {
					if($('.callout.module').length) {
						$('.callout.module').each(function() {
							const el = $(this);
							
						    let px = gsap.fromTo(el.find('.bg_image>img'), {
									y: "0%"
							    },{
									scrollTrigger: {
										trigger: el,
										start: "top bottom",
										end: "bottom top",
										scrub: true,
										invalidateOnRefresh: true,
									},
									ease: "none", 
									y: "20%"
								});
						});
					}
				},
				that.videoBg = function() {
				},
				that.buttons = function() {
					if ($(".button").length) {
						$(".button").each(function() {
							let x = 0, y = 0,
								button = $(this),
								bufferX = (button.outerWidth()*.5), bufferY = (button.outerHeight()*.5);
							
							button[0].addEventListener('mousemove',trail);
						
							function trail(evt) {
						      let rect = button[0].getBoundingClientRect();
							      x = (evt.clientX - rect.left);// - bufferX;
							      y = (evt.clientY - rect.top);// - bufferY;
							      //console.log("Left? : " + x + " ; Top? : " + y + ".");
							      updatePosition(x,y);
							}
							function updatePosition(left,top) {
								let xPos = left, yPos = top;
								
								$(button[0]).css({"--posX": xPos, "--posY": yPos});
							}
						});
					}
				};


			return that;

		})();
		
		
		nominations = (function() {
			var that = {};
			
			that.init = function() {
					that.nomineeInquiry();
					that.nominationForm();
					that.nomineeInquiryButtons();
					that.nominationButton();
					that.bannerButton();
					that.closeBannerButton();
					// that.minimizeBanner();
				},
				that.nomineeInquiry = function() {
					var data = JSON.parse( getCookie("nominee") );
					
					if(data) {
						var tpl = "",
	        				expand = data.minimize_banner ? ' minimize_banner':'',
	        				close = data.active_banner ? ' close_banner':'',
	        				inquiry = data.active_inquiry ? ' show_inquiry':'',
	        				me_msg = (data.member_engagement_message) ? data.member_engagement_message:"Ready to take the first step, "+data.nominee_firstname+"?",
	        				links = data.links ? data.links : {};


	                tpl += "<div id=\"nominee_banner\" class=\"nominee_banner-container"+expand+close+inquiry+"\">";
	                	tpl += "<div class=\"nominee_banner-content\">";
	                        tpl += "<div class=\"nominee_banner-content_wrap\">";
	                        	tpl += "<div class=\"nominee_banner-content_header\">";
	                        		tpl += "<p class=\"para_header-sans\">Welcome</p>";
	                        		tpl += "<h1 class=\"subtitle-sans\">You've been nominated by "+data.nominator_name+"</h1>";
	                        		tpl += "<button class=\"nominee_banner-content_min\">Minimize</button>";
	                        		tpl += "<button class=\"button nominee_inquiry-modal\">Inquire</button>";
	                        	tpl += "</div>";
	                        	tpl += "<div class=\"nominee_banner-lineage_wrap\">";
	                        	if(data.lineage_name) {
	                            	tpl += "<div class=\"nominee_banner-lineage_member\">";
	                            		tpl += "<div class=\"nominee_banner-lineage_img-wrap\">";
	                            			tpl += data.lineage_photo ? "<img src=\""+data.lineage_photo+"\" width=\"40\" height=\"40\" class=\"nominee_banner-lineage_img\"/>":"<div class=\"nominee_banner-lineage_img-fpo\">"+data.lineage_initials+"</div>";
	                            		tpl += "</div>";
	                            		tpl += "<div class=\"nominee_banner-lineage_details\">";
	                            			tpl += "<h3 class=\"nominee_banner-lineage_name\">"+data.lineage_name+"</h3>";
	                            			tpl += "<p class=\"nominee_banner-lineage_membership\">"+data.nominator_firstname+"'s Nominator</p>";
	                            		tpl += "</div>";
	                            	tpl += "</div>";
	                    		}
	                        	if(data.nominator_name) {
	                            	tpl += "<div class=\"nominee_banner-lineage_member\">";
	                            		tpl += "<div class=\"nominee_banner-lineage_img-wrap\">";
	                            			tpl += data.nominator_photo ? "<img src=\""+data.nominator_photo+"\" width=\"40\" height=\"40\" class=\"nominee_banner-lineage_img\"/>":"<div class=\"nominee_banner-lineage_img-fpo\">"+data.nominator_initials+"</div>";
	                            		tpl += "</div>";
	                            		tpl += "<div class=\"nominee_banner-lineage_details\">";
	                            			tpl += "<h3 class=\"nominee_banner-lineage_name\">"+data.nominator_name+"</h3>";
	                            			tpl += data.nominator_member_since ? "<p class=\"nominee_banner-lineage_membership\">Member Since <span class=\"accent_txt\">"+data.nominator_member_since+"</span></p>":"";
	                            		tpl += "</div>";
	                            	tpl += "</div>";
	                    		}
	                        	if(data.nominee_name) {
	                            	tpl += "<div class=\"nominee_banner-lineage_member\">";
	                                	tpl += "<div class=\"nominee_banner-lineage_img-wrap nominee_img\">";
	                                		tpl += data.nominee_photo ? "<img src=\""+data.nominee_photo+"\" width=\"40\" height=\"40\" class=\"nominee_banner-lineage_img\"/>":"<div class=\"nominee_banner-lineage_img-fpo\">You</div>";
	                                	tpl += "</div>";
	                                	tpl += "<div class=\"nominee_banner-lineage_details nominee_details\">";
	                                		tpl += "<h3 class=\"nominee_banner-lineage_name\">"+data.nominee_name+"</h3>";
	                                	tpl += "</div>";
	                            	tpl += "</div>";
	                        	}
	                        	tpl += "</div>";
	                        	tpl += "<div class=\"nominee_banner-content_message\">";
	                            	tpl += "<div class=\"nominee_banner-content_message-img\">";
	                                	tpl += data.nominator_photo ? "<img src=\""+data.nominator_photo+"\" width=\"40\" height=\"40\" class=\"nominee_banner-lineage_img\"/>":"<div class=\"nominee_banner-lineage_img-fpo\">"+data.nominator_initials+"</div>";
	                            	tpl += "</div>";
	                            	tpl += "<div class=\"nominee_banner-content_message-wrap\">";
	                                	tpl += "<p>"+data.nominee_firstname+",</p>";
	                                	tpl += "<p id=\"nominee_message\">"+nom_msg+"</p>";
	                                	tpl += "<p>"+data.nominator_firstname+"</p>";
	                            	tpl += "</div>";
	                        	tpl += "</div>";
	                        tpl += "</div>";
	                        	tpl += "<div class=\"nominee_banner-footer\">";
	                            	tpl += "<div class=\"nominee_banner-footer_header\"><h2>Explore Stagen</h2></div>";
	                            	tpl += "<div class=\"nominee_banner-footer_wrap\"><ol>";
	                            	for (const key in links) {
	                            		tpl += "<li><p>" + links[key].text + "</p>";
	                            		tpl += "<a class=\"nominee_banner-footer_link\" href=\"" + links[key].link.url + "\">" + links[key].link.title + "</a>";
	                            		tpl += "</li>";
	                            	}
	                            	tpl += "</ol><button class=\"button nominee_inquiry-modal\">Inquire</button></div>";
	                        	tpl += "</div>";
	                    tpl += "</div>";
	                    tpl += "<button class=\"nominee_banner-content_min minimized\">Minimize</button>";
	                    tpl += "<button class=\"nominee_banner-content_close\"><span class=\"nominee_banner-content_close-expand\">+</span></button>";
	                    tpl += "<button class=\"nominee_banner-me_bubble nominee_inquiry-modal\">";
	                    tpl += data.member_engagement_image ? "<img src=\""+data.member_engagement_image+"\" width=\"40\" height=\"40\" class=\"nominee_banner-lineage_img\"/>":"<div class=\"nominee_banner-lineage_img-fpo\">"+data.member_engagement_initials+"</div>";
	                    tpl += "<div class=\"nominee_banner-me_bubble-message\"><p>"+me_msg+"</p><span>Schedule a Call</span></div>";
	                tpl += "</button>";
	                tpl += "</div>";
	                    
	                    // ADD TEMPLATE
	                    $('#main-body').append(tpl);
	                    
	                    $('[data-nominee]').each(function() {
	                        var val = $(this).attr('data-nominee');
	                        
	                        if(!val) {
	                        	$(this).remove();
	                        	return;
	                        }
	                        if( $(this).is('a') ) {
	                        	$(this).attr('href', data[val]);
	                        } else if( $(this).is('img') ) {
	                        	$(this).attr('src', data[val]);
	                        } else {
	                        	$(this).text(data[val]);
	                        }
	                    });
	                    
						$('#nominee_inquiry .gfield.gform_hidden input[type=hidden]').val(data.nominee_name);
						$('#nominee_inquiry .gfield.me_email input').val('test@test.com');
					}
				},
				that.nominationForm = function() {
					var form = $('#nomination_form-1');

					if(form.length) {
						
						form.submit(function(e){
							e.preventDefault();
							
							form.find('.nomination_message.alert-success').css('display', 'block');
							form.find("input[type=text], input[type=email], textarea").val("");
							
							setTimeout(function(){
								form.find('.nomination_message').css('display', 'none');
							}, 30000);
						});
					}
				},
				that.nomineeInquiryButtons = function() {
					if ($('button.nominee_inquiry-modal').length) {
						$('button.nominee_inquiry-modal').on('click', function(e) {
							e.preventDefault();

							var el = $(this),
								modalID = "nominee_inquiry",
								modal = $("#" + modalID);

							if (modal.hasClass('active-modal')) {
								modal.removeClass('active-modal');
								$('body').removeClass('scroll-lock');
							}
							else {
								modal.addClass('active-modal');
								$('body').addClass('scroll-lock');
							}

							$('#' + modalID + ' .modal-close').on('click', function(e) {
								modal.removeClass('active-modal');
								$('body').removeClass('scroll-lock');
							});
						});
						
						
						
						$('.button-email_assistant').on('click', function(e) {
							$('#nominee_inquiry').addClass('hide_header');
							$('#nominee_inquiry').addClass('show_inquiry_ea');
						});
						
						$('.button-email_me').on('click', function(e) {
							$('#nominee_inquiry').addClass('hide_header');
							$('#nominee_inquiry').addClass('show_inquiry_me');
						});
						
						$('.button-inquiry_back').on('click', function(e) {
							$('#nominee_inquiry').removeClass('hide_header');
							$('#nominee_inquiry').removeClass('show_inquiry_me');
							$('#nominee_inquiry').removeClass('show_inquiry_ea');
						});
					}
				},
				that.nominationButton = function() {
					if ($('.nomination-modal').length) {

						$('.nomination-modal').on('click', function(e) {
							e.preventDefault();

							var el = $(this),
								modalID = "nomination_modal",
								modal = $("#" + modalID);
								
							if (modal.length) {

								if (modal.hasClass('active-modal')) {
									modal.removeClass('active-modal');
									$('body').removeClass('scroll-lock');
								}
								else {
									modal.addClass('active-modal');
									$('body').addClass('scroll-lock');
								}
	
								$('#' + modalID + ' .modal-close').on('click', function(e) {
									modal.removeClass('active-modal');
									$('body').removeClass('scroll-lock');
								});
								
							}
						});
					}
				},
				that.bannerButton = function() {
					var data = JSON.parse( getCookie("nominee") );
					
					if (data && $('.nominee_banner-content_min').length) {

						$('.nominee_banner-content_min').click(function() {
							// fire off the request to /redirect.php
							// var expand = $('#nominee_banner').hasClass('minimize_banner') ? "expand":"minimize";
							// var request = $.ajax({
							// 	url: ajaxurl + "/update.php?action="+expand,
							// 	type: "post"
							// });

							// callback handler that will be called on success
							// request.done(function(response, textStatus, jqXHR) {
								// log a message to the console
								if($('#nominee_banner').hasClass('minimize_banner')) {
									$('#nominee_banner').removeClass('minimize_banner');
										data.minimize_banner = false;
								} else {
									$('#nominee_banner').addClass('minimize_banner');
										data.minimize_banner = true;
								}
								$('#nominee_banner').addClass('show_inquiry');
									data.active_inquiry = true;
								
								document.cookie = "nominee="+JSON.stringify(data)+"; path=/; expires=" + data.expires;
							// });

							// callback handler that will be called on failure
							// request.fail(function(jqXHR, textStatus, errorThrown) {
							// 	// log the error to the console
							// 	console.error(
							// 		"The following error occured: " +
							// 		textStatus, errorThrown
							// 	);
							// });

						});
					}
				},
				that.closeBannerButton = function() {
					var data = JSON.parse( getCookie("nominee") );
					
					if (data && $('.nominee_banner-content_close').length) {

						$('.nominee_banner-content_close').click(function() {
							// fire off the request to /redirect.php
							// var request = $.ajax({
							// 	url: ajaxurl + "/update.php?action=close",
							// 	type: "post"
							// });

							// callback handler that will be called on success
							// request.done(function(response, textStatus, jqXHR) {
								// log a message to the console
								$('#nominee_banner').toggleClass('close_banner');
									data.active_banner = !data.active_banner;
								$('#nominee_banner').removeClass('minimize_banner');
									data.minimize_banner = false;
								$('#nominee_banner').addClass('show_inquiry');
									data.active_inquiry = true;
									
								document.cookie = "nominee="+JSON.stringify(data)+"; path=/; expires=" + data.expires;
							// });

							// callback handler that will be called on failure
							// request.fail(function(jqXHR, textStatus, errorThrown) {
							// 	// log the error to the console
							// 	console.error(
							// 		"The following error occured: " +
							// 		textStatus, errorThrown
							// 	);
							// });

						});
					}
				},
				that.minimizeBanner = function() {
					var data = JSON.parse( getCookie("nominee") );
					
					if (data && !data.minimize_banner) {
						$('#nominee_banner').addClass('minimize_banner');
						data.minimize_banner = true;
						$('#nominee_banner').addClass('show_inquiry');
						data.active_inquiry = true;
						document.cookie = 'nominee=' + JSON.stringify(data) + '; path=/; expires=' + data.expires;
					// 	);
					// });
					}
				};
				
			return that;
			
		})();


		var rotators = (function() {
			var that = {};

			that.init = function() {
					that.rotatorModule();
				},
				that.rotatorModule = function() {
					
					if ($(".rotator-slider").length) {
						const swiper = new Swiper('.rotator-slider', {
							pagination: {
								el: '.swiper-pagination',
							},
							navigation: {
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev',
							},
							a11y: {
								enabled: true,
							},
							loop: true,
							speed: 1250,
							cssMode: false,
							autoplay: {
								delay: 6000,
								pauseOnMouseEnter: false,
							},
						});
					}

				};


			return that;

		})();
		
		
		function smartResize() {
			var vH = $(window).height();

			$(window).on("debouncedresize", function(event) {
				vH = $(window).height();
			});
		};


		loadPage.init();
		nominations.init();
		parallax.init();
		rotators.init();
		smartResize();

	} // pagescripts

}); /* end of as page load scripts =======================================================================================*/

/* =============================================================================
   Cookie Consent Banner
   Accept / Decline buttons + "Cookie Preferences" footer link to reopen.
   Integrates with WP Consent API (wp_set_consent).
   ============================================================================= */
(function () {
	'use strict';

	var BANNER_ID      = 'cookie_banner';
	var ACCEPT_ID      = 'cookie_banner_accept';
	var DECLINE_ID     = 'cookie_banner_decline';
	var REOPEN_ID      = 'cookie_prefs_reopen';
	var CONSENT_COOKIE = 'wp_consent_marketing';

	var CATEGORIES = ['marketing', 'statistics'];

	// ── Helpers ────────────────────────────────────────────────────────────────

	function setConsent(value) {
		if (typeof wp_set_consent === 'function') {
			CATEGORIES.forEach(function (cat) {
				wp_set_consent(cat, value);
			});
		}
	}

	function hideBanner(banner) {
		banner.classList.add('is-hidden');
		setTimeout(function () {
			banner.setAttribute('aria-hidden', 'true');
			banner.style.display = 'none';
		}, 400);
	}

	function showBanner(banner) {
		banner.style.display = '';
		// Reflow before removing class so transition plays.
		requestAnimationFrame(function () {
			banner.removeAttribute('aria-hidden');
			banner.classList.remove('is-hidden');
		});
	}

	function clearConsentCookies() {
		// Expire both consent cookies so PHP re-shows the banner on next load.
		CATEGORIES.forEach(function (cat) {
			document.cookie = 'wp_consent_' + cat + '=;path=/;max-age=0';
		});
	}

	// ── Init ───────────────────────────────────────────────────────────────────

	function init() {
		var banner     = document.getElementById(BANNER_ID);
		var acceptBtn  = document.getElementById(ACCEPT_ID);
		var declineBtn = document.getElementById(DECLINE_ID);
		var reopenBtn  = document.getElementById(REOPEN_ID);

		// Read consent mode from PHP (optin = California, optout = everywhere else).
		var consentType = banner ? (banner.getAttribute('data-consent-type') || 'optout') : 'optout';

		// Accept — grant all categories.
		// Consent bridge script fires gtag('consent','update') in real-time.
		// Server-side HubSpot/GA defaults apply on next natural page load.
		if (acceptBtn && banner) {
			acceptBtn.addEventListener('click', function () {
				setConsent('allow');
				hideBanner(banner);
			});
		}

		// Decline — deny all categories.
		if (declineBtn && banner) {
			declineBtn.addEventListener('click', function () {
				setConsent('deny');
				hideBanner(banner);
			});
		}

		// "Cookie Preferences" footer link — clear consent cookies and re-show banner.
		// Reloads if banner wasn't rendered server-side (consent was already set).
		if (reopenBtn) {
			reopenBtn.addEventListener('click', function (e) {
				e.preventDefault();
				clearConsentCookies();
				document.documentElement.classList.remove('has-wp-consent');
				if (banner) {
					showBanner(banner);
				} else {
					window.location.reload();
				}
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

})();